/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: boolean | null | undefined;
  _gt?: boolean | null | undefined;
  _gte?: boolean | null | undefined;
  _in?: Array<boolean> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: boolean | null | undefined;
  _lte?: boolean | null | undefined;
  _neq?: boolean | null | undefined;
  _nin?: Array<boolean> | null | undefined;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _is_null?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

/** Boolean expression to filter rows from the table "additional_address". All fields are combined with a logical 'AND'. */
export type Additional_Address_Bool_Exp = {
  _and?: Array<Additional_Address_Bool_Exp> | null | undefined;
  _not?: Additional_Address_Bool_Exp | null | undefined;
  _or?: Array<Additional_Address_Bool_Exp> | null | undefined;
  address_1?: String_Comparison_Exp | null | undefined;
  address_2?: String_Comparison_Exp | null | undefined;
  city?: String_Comparison_Exp | null | undefined;
  country?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  postal_code?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "additional_address" */
export type Additional_Address_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'additional_address_pkey';

/** input type for inserting data into table "additional_address" */
export type Additional_Address_Insert_Input = {
  address_1?: string | null | undefined;
  address_2?: string | null | undefined;
  city?: string | null | undefined;
  country?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  postal_code?: string | null | undefined;
};

/** input type for inserting object relation for remote table "additional_address" */
export type Additional_Address_Obj_Rel_Insert_Input = {
  data: Additional_Address_Insert_Input;
  /** upsert condition */
  on_conflict?: Additional_Address_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "additional_address" */
export type Additional_Address_On_Conflict = {
  constraint: Additional_Address_Constraint;
  update_columns?: Array<Additional_Address_Update_Column>;
  where?: Additional_Address_Bool_Exp | null | undefined;
};

/** update columns of table "additional_address" */
export type Additional_Address_Update_Column =
  /** column name */
  | 'address_1'
  /** column name */
  | 'address_2'
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'postal_code';

export type Address_Aggregate_Bool_Exp = {
  count?: Address_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Address_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Address_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Address_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "address" */
export type Address_Arr_Rel_Insert_Input = {
  data: Array<Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: Address_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: Array<Address_Bool_Exp> | null | undefined;
  _not?: Address_Bool_Exp | null | undefined;
  _or?: Array<Address_Bool_Exp> | null | undefined;
  administrativeAreaLevel1?: String_Comparison_Exp | null | undefined;
  administrativeAreaLevel2?: String_Comparison_Exp | null | undefined;
  administrativeAreaLevel3?: String_Comparison_Exp | null | undefined;
  administrativeAreaLevel4?: String_Comparison_Exp | null | undefined;
  administrativeAreaLevel5?: String_Comparison_Exp | null | undefined;
  archipelago?: String_Comparison_Exp | null | undefined;
  colloquialArea?: String_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  companyId?: Uuid_Comparison_Exp | null | undefined;
  continent?: String_Comparison_Exp | null | undefined;
  countryCode?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  description?: String_Comparison_Exp | null | undefined;
  formattedAddress?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  intersection?: String_Comparison_Exp | null | undefined;
  latitude?: Numeric_Comparison_Exp | null | undefined;
  locality?: String_Comparison_Exp | null | undefined;
  longitude?: Numeric_Comparison_Exp | null | undefined;
  neighborhood?: String_Comparison_Exp | null | undefined;
  placeId?: String_Comparison_Exp | null | undefined;
  plusCode?: String_Comparison_Exp | null | undefined;
  postBox?: String_Comparison_Exp | null | undefined;
  postalCode?: String_Comparison_Exp | null | undefined;
  postalCodePrefix?: String_Comparison_Exp | null | undefined;
  postalCodeSuffix?: String_Comparison_Exp | null | undefined;
  postalTown?: String_Comparison_Exp | null | undefined;
  premise?: String_Comparison_Exp | null | undefined;
  route?: String_Comparison_Exp | null | undefined;
  streetAddress?: String_Comparison_Exp | null | undefined;
  streetNumber?: String_Comparison_Exp | null | undefined;
  sublocality?: String_Comparison_Exp | null | undefined;
  sublocalityLevel1?: String_Comparison_Exp | null | undefined;
  sublocalityLevel2?: String_Comparison_Exp | null | undefined;
  sublocalityLevel3?: String_Comparison_Exp | null | undefined;
  sublocalityLevel4?: String_Comparison_Exp | null | undefined;
  sublocalityLevel5?: String_Comparison_Exp | null | undefined;
  subpremise?: String_Comparison_Exp | null | undefined;
  townSquare?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "address" */
export type Address_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_d92de1f82754668b5f5f5dd4fd5'
  /** unique or primary key constraint on columns "companyId" */
  | 'REL_c3fdf52cd6b4cbbeca8f5184fb';

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  administrativeAreaLevel1?: string | null | undefined;
  administrativeAreaLevel2?: string | null | undefined;
  administrativeAreaLevel3?: string | null | undefined;
  administrativeAreaLevel4?: string | null | undefined;
  administrativeAreaLevel5?: string | null | undefined;
  archipelago?: string | null | undefined;
  colloquialArea?: string | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  companyId?: string | null | undefined;
  continent?: string | null | undefined;
  countryCode?: string | null | undefined;
  created_at?: string | null | undefined;
  description?: string | null | undefined;
  formattedAddress?: string | null | undefined;
  id?: string | null | undefined;
  intersection?: string | null | undefined;
  latitude?: number | null | undefined;
  locality?: string | null | undefined;
  longitude?: number | null | undefined;
  neighborhood?: string | null | undefined;
  placeId?: string | null | undefined;
  plusCode?: string | null | undefined;
  postBox?: string | null | undefined;
  postalCode?: string | null | undefined;
  postalCodePrefix?: string | null | undefined;
  postalCodeSuffix?: string | null | undefined;
  postalTown?: string | null | undefined;
  premise?: string | null | undefined;
  route?: string | null | undefined;
  streetAddress?: string | null | undefined;
  streetNumber?: string | null | undefined;
  sublocality?: string | null | undefined;
  sublocalityLevel1?: string | null | undefined;
  sublocalityLevel2?: string | null | undefined;
  sublocalityLevel3?: string | null | undefined;
  sublocalityLevel4?: string | null | undefined;
  sublocalityLevel5?: string | null | undefined;
  subpremise?: string | null | undefined;
  townSquare?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: Address_Bool_Exp | null | undefined;
};

/** select columns of table "address" */
export type Address_Select_Column =
  /** column name */
  | 'administrativeAreaLevel1'
  /** column name */
  | 'administrativeAreaLevel2'
  /** column name */
  | 'administrativeAreaLevel3'
  /** column name */
  | 'administrativeAreaLevel4'
  /** column name */
  | 'administrativeAreaLevel5'
  /** column name */
  | 'archipelago'
  /** column name */
  | 'colloquialArea'
  /** column name */
  | 'companyId'
  /** column name */
  | 'continent'
  /** column name */
  | 'countryCode'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'formattedAddress'
  /** column name */
  | 'id'
  /** column name */
  | 'intersection'
  /** column name */
  | 'latitude'
  /** column name */
  | 'locality'
  /** column name */
  | 'longitude'
  /** column name */
  | 'neighborhood'
  /** column name */
  | 'placeId'
  /** column name */
  | 'plusCode'
  /** column name */
  | 'postBox'
  /** column name */
  | 'postalCode'
  /** column name */
  | 'postalCodePrefix'
  /** column name */
  | 'postalCodeSuffix'
  /** column name */
  | 'postalTown'
  /** column name */
  | 'premise'
  /** column name */
  | 'route'
  /** column name */
  | 'streetAddress'
  /** column name */
  | 'streetNumber'
  /** column name */
  | 'sublocality'
  /** column name */
  | 'sublocalityLevel1'
  /** column name */
  | 'sublocalityLevel2'
  /** column name */
  | 'sublocalityLevel3'
  /** column name */
  | 'sublocalityLevel4'
  /** column name */
  | 'sublocalityLevel5'
  /** column name */
  | 'subpremise'
  /** column name */
  | 'townSquare'
  /** column name */
  | 'updated_at';

/** update columns of table "address" */
export type Address_Update_Column =
  /** column name */
  | 'administrativeAreaLevel1'
  /** column name */
  | 'administrativeAreaLevel2'
  /** column name */
  | 'administrativeAreaLevel3'
  /** column name */
  | 'administrativeAreaLevel4'
  /** column name */
  | 'administrativeAreaLevel5'
  /** column name */
  | 'archipelago'
  /** column name */
  | 'colloquialArea'
  /** column name */
  | 'companyId'
  /** column name */
  | 'continent'
  /** column name */
  | 'countryCode'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'formattedAddress'
  /** column name */
  | 'id'
  /** column name */
  | 'intersection'
  /** column name */
  | 'latitude'
  /** column name */
  | 'locality'
  /** column name */
  | 'longitude'
  /** column name */
  | 'neighborhood'
  /** column name */
  | 'placeId'
  /** column name */
  | 'plusCode'
  /** column name */
  | 'postBox'
  /** column name */
  | 'postalCode'
  /** column name */
  | 'postalCodePrefix'
  /** column name */
  | 'postalCodeSuffix'
  /** column name */
  | 'postalTown'
  /** column name */
  | 'premise'
  /** column name */
  | 'route'
  /** column name */
  | 'streetAddress'
  /** column name */
  | 'streetNumber'
  /** column name */
  | 'sublocality'
  /** column name */
  | 'sublocalityLevel1'
  /** column name */
  | 'sublocalityLevel2'
  /** column name */
  | 'sublocalityLevel3'
  /** column name */
  | 'sublocalityLevel4'
  /** column name */
  | 'sublocalityLevel5'
  /** column name */
  | 'subpremise'
  /** column name */
  | 'townSquare'
  /** column name */
  | 'updated_at';

export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

/** Boolean expression to compare columns of type "availability_status_enum". All fields are combined with logical 'AND'. */
export type Availability_Status_Enum_Comparison_Exp = {
  _eq?: Availability_Status_Enum | null | undefined;
  _in?: Array<Availability_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Availability_Status_Enum | null | undefined;
  _nin?: Array<Availability_Status_Enum> | null | undefined;
};

export type Base_Unit_Aggregate_Bool_Exp = {
  count?: Base_Unit_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Base_Unit_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Base_Unit_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Base_Unit_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "base_unit" */
export type Base_Unit_Arr_Rel_Insert_Input = {
  data: Array<Base_Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: Base_Unit_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "base_unit". All fields are combined with a logical 'AND'. */
export type Base_Unit_Bool_Exp = {
  _and?: Array<Base_Unit_Bool_Exp> | null | undefined;
  _not?: Base_Unit_Bool_Exp | null | undefined;
  _or?: Array<Base_Unit_Bool_Exp> | null | undefined;
  availability?: Availability_Status_Enum_Comparison_Exp | null | undefined;
  billing_type?: Billing_Type_Enum_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_default_price_id?: Uuid_Comparison_Exp | null | undefined;
  deprecated_productSku?: String_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  gtin?: String_Comparison_Exp | null | undefined;
  gtin_type?: Gtin_Type_Enum_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  main_photo?: Photo_Bool_Exp | null | undefined;
  main_photo_id?: Uuid_Comparison_Exp | null | undefined;
  packagings?: Packaging_Bool_Exp | null | undefined;
  packagings_aggregate?: Packaging_Aggregate_Bool_Exp | null | undefined;
  photos?: Base_Unit_Photo_Bool_Exp | null | undefined;
  photos_aggregate?: Base_Unit_Photo_Aggregate_Bool_Exp | null | undefined;
  product?: Product_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  social_tags?: Social_Tag_Bool_Exp | null | undefined;
  social_tags_aggregate?: Social_Tag_Aggregate_Bool_Exp | null | undefined;
  suggested_retail_price?: Numeric_Comparison_Exp | null | undefined;
  unit_net_content?: Numeric_Comparison_Exp | null | undefined;
  unit_quantity?: Int_Comparison_Exp | null | undefined;
  unit_type?: Base_Unit_Type_Enum_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "base_unit" */
export type Base_Unit_Constraint =
  /** unique or primary key constraint on columns "sku", "company_id" */
  | 'base_unit_company_id_sku_key'
  /** unique or primary key constraint on columns "id", "product_id" */
  | 'base_unit_id_product_id_uq'
  /** unique or primary key constraint on columns "id" */
  | 'base_unit_pkey'
  /** unique or primary key constraint on columns "gtin", "company_id" */
  | 'gtin_company_id_uq';

export type Base_Unit_History_Aggregate_Bool_Exp = {
  count?: Base_Unit_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Base_Unit_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Base_Unit_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Base_Unit_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "base_unit_history" */
export type Base_Unit_History_Arr_Rel_Insert_Input = {
  data: Array<Base_Unit_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Base_Unit_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "base_unit_history". All fields are combined with a logical 'AND'. */
export type Base_Unit_History_Bool_Exp = {
  _and?: Array<Base_Unit_History_Bool_Exp> | null | undefined;
  _not?: Base_Unit_History_Bool_Exp | null | undefined;
  _or?: Array<Base_Unit_History_Bool_Exp> | null | undefined;
  availability?: String_Comparison_Exp | null | undefined;
  billing_type?: Billing_Type_Enum_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_default_price_id?: Uuid_Comparison_Exp | null | undefined;
  deprecated_productSku?: String_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  gtin?: String_Comparison_Exp | null | undefined;
  gtin_type?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  main_photo?: Photo_Bool_Exp | null | undefined;
  main_photo_id?: Uuid_Comparison_Exp | null | undefined;
  packagings?: Packaging_History_Bool_Exp | null | undefined;
  packagings_aggregate?: Packaging_History_Aggregate_Bool_Exp | null | undefined;
  photos?: Base_Unit_Photo_History_Bool_Exp | null | undefined;
  photos_aggregate?: Base_Unit_Photo_History_Aggregate_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  suggested_retail_price?: Numeric_Comparison_Exp | null | undefined;
  unit_net_content?: Numeric_Comparison_Exp | null | undefined;
  unit_quantity?: Int_Comparison_Exp | null | undefined;
  unit_type?: Base_Unit_Type_Enum_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "base_unit_history" */
export type Base_Unit_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'base_unit_history_pkey';

/** input type for inserting data into table "base_unit_history" */
export type Base_Unit_History_Insert_Input = {
  availability?: string | null | undefined;
  billing_type?: Billing_Type_Enum | null | undefined;
  company_id?: string | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum | null | undefined;
  created_date?: string | null | undefined;
  deprecated_default_price_id?: string | null | undefined;
  deprecated_productSku?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  gtin?: string | null | undefined;
  gtin_type?: string | null | undefined;
  id?: string | null | undefined;
  main_photo?: Photo_Obj_Rel_Insert_Input | null | undefined;
  main_photo_id?: string | null | undefined;
  packagings?: Packaging_History_Arr_Rel_Insert_Input | null | undefined;
  photos?: Base_Unit_Photo_History_Arr_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  sku?: number | null | undefined;
  suggested_retail_price?: number | null | undefined;
  unit_net_content?: number | null | undefined;
  unit_quantity?: number | null | undefined;
  unit_type?: Base_Unit_Type_Enum | null | undefined;
};

/** input type for inserting object relation for remote table "base_unit_history" */
export type Base_Unit_History_Obj_Rel_Insert_Input = {
  data: Base_Unit_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Base_Unit_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "base_unit_history" */
export type Base_Unit_History_On_Conflict = {
  constraint: Base_Unit_History_Constraint;
  update_columns?: Array<Base_Unit_History_Update_Column>;
  where?: Base_Unit_History_Bool_Exp | null | undefined;
};

/** select columns of table "base_unit_history" */
export type Base_Unit_History_Select_Column =
  /** column name */
  | 'availability'
  /** column name */
  | 'billing_type'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'main_photo_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'suggested_retail_price'
  /** column name */
  | 'unit_net_content'
  /** column name */
  | 'unit_quantity'
  /** column name */
  | 'unit_type';

/** update columns of table "base_unit_history" */
export type Base_Unit_History_Update_Column =
  /** column name */
  | 'availability'
  /** column name */
  | 'billing_type'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'main_photo_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'suggested_retail_price'
  /** column name */
  | 'unit_net_content'
  /** column name */
  | 'unit_quantity'
  /** column name */
  | 'unit_type';

/** input type for inserting data into table "base_unit" */
export type Base_Unit_Insert_Input = {
  availability?: Availability_Status_Enum | null | undefined;
  billing_type?: Billing_Type_Enum | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum | null | undefined;
  created_date?: string | null | undefined;
  deprecated_default_price_id?: string | null | undefined;
  deprecated_productSku?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  gtin?: string | null | undefined;
  gtin_type?: Gtin_Type_Enum | null | undefined;
  id?: string | null | undefined;
  main_photo?: Photo_Obj_Rel_Insert_Input | null | undefined;
  main_photo_id?: string | null | undefined;
  packagings?: Packaging_Arr_Rel_Insert_Input | null | undefined;
  photos?: Base_Unit_Photo_Arr_Rel_Insert_Input | null | undefined;
  product?: Product_Obj_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  sku?: number | null | undefined;
  social_tags?: Social_Tag_Arr_Rel_Insert_Input | null | undefined;
  suggested_retail_price?: number | null | undefined;
  unit_net_content?: number | null | undefined;
  unit_quantity?: number | null | undefined;
  unit_type?: Base_Unit_Type_Enum | null | undefined;
};

/** input type for inserting object relation for remote table "base_unit" */
export type Base_Unit_Obj_Rel_Insert_Input = {
  data: Base_Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: Base_Unit_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "base_unit" */
export type Base_Unit_On_Conflict = {
  constraint: Base_Unit_Constraint;
  update_columns?: Array<Base_Unit_Update_Column>;
  where?: Base_Unit_Bool_Exp | null | undefined;
};

export type Base_Unit_Photo_Aggregate_Bool_Exp = {
  count?: Base_Unit_Photo_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Base_Unit_Photo_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Base_Unit_Photo_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Base_Unit_Photo_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "base_unit_photo" */
export type Base_Unit_Photo_Arr_Rel_Insert_Input = {
  data: Array<Base_Unit_Photo_Insert_Input>;
  /** upsert condition */
  on_conflict?: Base_Unit_Photo_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "base_unit_photo". All fields are combined with a logical 'AND'. */
export type Base_Unit_Photo_Bool_Exp = {
  _and?: Array<Base_Unit_Photo_Bool_Exp> | null | undefined;
  _not?: Base_Unit_Photo_Bool_Exp | null | undefined;
  _or?: Array<Base_Unit_Photo_Bool_Exp> | null | undefined;
  base_unit_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  photo?: Photo_Bool_Exp | null | undefined;
  photo_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "base_unit_photo" */
export type Base_Unit_Photo_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'base_unit_photo_pkey';

export type Base_Unit_Photo_History_Aggregate_Bool_Exp = {
  count?: Base_Unit_Photo_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Base_Unit_Photo_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Base_Unit_Photo_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Base_Unit_Photo_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "base_unit_photo_history" */
export type Base_Unit_Photo_History_Arr_Rel_Insert_Input = {
  data: Array<Base_Unit_Photo_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Base_Unit_Photo_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "base_unit_photo_history". All fields are combined with a logical 'AND'. */
export type Base_Unit_Photo_History_Bool_Exp = {
  _and?: Array<Base_Unit_Photo_History_Bool_Exp> | null | undefined;
  _not?: Base_Unit_Photo_History_Bool_Exp | null | undefined;
  _or?: Array<Base_Unit_Photo_History_Bool_Exp> | null | undefined;
  base_unit_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  photo?: Photo_Bool_Exp | null | undefined;
  photo_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "base_unit_photo_history" */
export type Base_Unit_Photo_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'base_unit_photo_history_pkey';

/** input type for inserting data into table "base_unit_photo_history" */
export type Base_Unit_Photo_History_Insert_Input = {
  base_unit_id?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  photo?: Photo_Obj_Rel_Insert_Input | null | undefined;
  photo_id?: string | null | undefined;
};

/** on_conflict condition type for table "base_unit_photo_history" */
export type Base_Unit_Photo_History_On_Conflict = {
  constraint: Base_Unit_Photo_History_Constraint;
  update_columns?: Array<Base_Unit_Photo_History_Update_Column>;
  where?: Base_Unit_Photo_History_Bool_Exp | null | undefined;
};

/** select columns of table "base_unit_photo_history" */
export type Base_Unit_Photo_History_Select_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** update columns of table "base_unit_photo_history" */
export type Base_Unit_Photo_History_Update_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** input type for inserting data into table "base_unit_photo" */
export type Base_Unit_Photo_Insert_Input = {
  base_unit_id?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  photo?: Photo_Obj_Rel_Insert_Input | null | undefined;
  photo_id?: string | null | undefined;
};

/** on_conflict condition type for table "base_unit_photo" */
export type Base_Unit_Photo_On_Conflict = {
  constraint: Base_Unit_Photo_Constraint;
  update_columns?: Array<Base_Unit_Photo_Update_Column>;
  where?: Base_Unit_Photo_Bool_Exp | null | undefined;
};

/** select columns of table "base_unit_photo" */
export type Base_Unit_Photo_Select_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** update columns of table "base_unit_photo" */
export type Base_Unit_Photo_Update_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** select columns of table "base_unit" */
export type Base_Unit_Select_Column =
  /** column name */
  | 'availability'
  /** column name */
  | 'billing_type'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'main_photo_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'suggested_retail_price'
  /** column name */
  | 'unit_net_content'
  /** column name */
  | 'unit_quantity'
  /** column name */
  | 'unit_type';

export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

/** Boolean expression to compare columns of type "base_unit_type_enum". All fields are combined with logical 'AND'. */
export type Base_Unit_Type_Enum_Comparison_Exp = {
  _eq?: Base_Unit_Type_Enum | null | undefined;
  _in?: Array<Base_Unit_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Base_Unit_Type_Enum | null | undefined;
  _nin?: Array<Base_Unit_Type_Enum> | null | undefined;
};

/** update columns of table "base_unit" */
export type Base_Unit_Update_Column =
  /** column name */
  | 'availability'
  /** column name */
  | 'billing_type'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'main_photo_id'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'suggested_retail_price'
  /** column name */
  | 'unit_net_content'
  /** column name */
  | 'unit_quantity'
  /** column name */
  | 'unit_type';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

/** Boolean expression to compare columns of type "billing_type_enum". All fields are combined with logical 'AND'. */
export type Billing_Type_Enum_Comparison_Exp = {
  _eq?: Billing_Type_Enum | null | undefined;
  _in?: Array<Billing_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Billing_Type_Enum | null | undefined;
  _nin?: Array<Billing_Type_Enum> | null | undefined;
};

export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

/** Boolean expression to compare columns of type "brand_enum". All fields are combined with logical 'AND'. */
export type Brand_Enum_Comparison_Exp = {
  _eq?: Brand_Enum | null | undefined;
  _in?: Array<Brand_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Brand_Enum | null | undefined;
  _nin?: Array<Brand_Enum> | null | undefined;
};

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

/** Boolean expression to compare columns of type "business_profile_enum". All fields are combined with logical 'AND'. */
export type Business_Profile_Enum_Comparison_Exp = {
  _eq?: Business_Profile_Enum | null | undefined;
  _in?: Array<Business_Profile_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Business_Profile_Enum | null | undefined;
  _nin?: Array<Business_Profile_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "catalog". All fields are combined with a logical 'AND'. */
export type Catalog_Bool_Exp = {
  _and?: Array<Catalog_Bool_Exp> | null | undefined;
  _not?: Catalog_Bool_Exp | null | undefined;
  _or?: Array<Catalog_Bool_Exp> | null | undefined;
  catalog_packagings?: Catalog_Packaging_Bool_Exp | null | undefined;
  catalog_packagings_aggregate?: Catalog_Packaging_Aggregate_Bool_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  contracts?: Contract_Bool_Exp | null | undefined;
  contracts_aggregate?: Contract_Aggregate_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "catalog" */
export type Catalog_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'catalog_pkey';

/** input type for inserting data into table "catalog" */
export type Catalog_Insert_Input = {
  catalog_packagings?: Catalog_Packaging_Arr_Rel_Insert_Input | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  contracts?: Contract_Arr_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "catalog" */
export type Catalog_Obj_Rel_Insert_Input = {
  data: Catalog_Insert_Input;
  /** upsert condition */
  on_conflict?: Catalog_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "catalog" */
export type Catalog_On_Conflict = {
  constraint: Catalog_Constraint;
  update_columns?: Array<Catalog_Update_Column>;
  where?: Catalog_Bool_Exp | null | undefined;
};

export type Catalog_Packaging_Aggregate_Bool_Exp = {
  count?: Catalog_Packaging_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Catalog_Packaging_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Catalog_Packaging_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Catalog_Packaging_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "catalog_packaging" */
export type Catalog_Packaging_Arr_Rel_Insert_Input = {
  data: Array<Catalog_Packaging_Insert_Input>;
  /** upsert condition */
  on_conflict?: Catalog_Packaging_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "catalog_packaging". All fields are combined with a logical 'AND'. */
export type Catalog_Packaging_Bool_Exp = {
  _and?: Array<Catalog_Packaging_Bool_Exp> | null | undefined;
  _not?: Catalog_Packaging_Bool_Exp | null | undefined;
  _or?: Array<Catalog_Packaging_Bool_Exp> | null | undefined;
  catalog?: Catalog_Bool_Exp | null | undefined;
  catalog_id?: Uuid_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  discount?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  packaging?: Packaging_Bool_Exp | null | undefined;
  packaging_sku?: Int_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "catalog_packaging" */
export type Catalog_Packaging_Constraint =
  /** unique or primary key constraint on columns "catalog_id", "packaging_sku", "company_id" */
  | 'catalog_packaging_packaging_sku_company_id_catalog_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'catalog_packaging_pkey';

/** input type for inserting data into table "catalog_packaging" */
export type Catalog_Packaging_Insert_Input = {
  catalog?: Catalog_Obj_Rel_Insert_Input | null | undefined;
  catalog_id?: string | null | undefined;
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  packaging?: Packaging_Obj_Rel_Insert_Input | null | undefined;
  packaging_sku?: number | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "catalog_packaging" */
export type Catalog_Packaging_On_Conflict = {
  constraint: Catalog_Packaging_Constraint;
  update_columns?: Array<Catalog_Packaging_Update_Column>;
  where?: Catalog_Packaging_Bool_Exp | null | undefined;
};

/** select columns of table "catalog_packaging" */
export type Catalog_Packaging_Select_Column =
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** update columns of table "catalog_packaging" */
export type Catalog_Packaging_Update_Column =
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** update columns of table "catalog" */
export type Catalog_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at';

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string | null | undefined;
  _is_null?: boolean | null | undefined;
  /** does the column match the given pattern */
  _like?: string | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string | null | undefined;
  /** does the column NOT match the given pattern */
  _nlike?: string | null | undefined;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string | null | undefined;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string | null | undefined;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string | null | undefined;
  /** does the column match the given SQL regular expression */
  _similar?: string | null | undefined;
};

export type Comment_Aggregate_Bool_Exp = {
  bool_and?: Comment_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Comment_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Comment_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Comment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Comment_Select_Column_Comment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Comment_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Comment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Comment_Select_Column_Comment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Comment_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Comment_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Comment_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Comment_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "comment" */
export type Comment_Arr_Rel_Insert_Input = {
  data: Array<Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Comment_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "comment". All fields are combined with a logical 'AND'. */
export type Comment_Bool_Exp = {
  _and?: Array<Comment_Bool_Exp> | null | undefined;
  _not?: Comment_Bool_Exp | null | undefined;
  _or?: Array<Comment_Bool_Exp> | null | undefined;
  attachments?: Document_Bool_Exp | null | undefined;
  attachments_aggregate?: Document_Aggregate_Bool_Exp | null | undefined;
  content?: String_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deleted?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  modified_date?: Timestamptz_Comparison_Exp | null | undefined;
  order?: Order_Bool_Exp | null | undefined;
  order_reference_id?: Uuid_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  type?: Comment_Type_Enum_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
  user_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "comment" */
export type Comment_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'comment_pkey'
  /** unique or primary key constraint on columns "reference_id" */
  | 'comment_reference_id_key';

export type Comment_History_Aggregate_Bool_Exp = {
  bool_and?: Comment_History_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Comment_History_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Comment_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Comment_History_Aggregate_Bool_Exp_Bool_And = {
  arguments: Comment_History_Select_Column_Comment_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Comment_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Comment_History_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Comment_History_Select_Column_Comment_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Comment_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Comment_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Comment_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Comment_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "comment_history" */
export type Comment_History_Arr_Rel_Insert_Input = {
  data: Array<Comment_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Comment_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "comment_history". All fields are combined with a logical 'AND'. */
export type Comment_History_Bool_Exp = {
  _and?: Array<Comment_History_Bool_Exp> | null | undefined;
  _not?: Comment_History_Bool_Exp | null | undefined;
  _or?: Array<Comment_History_Bool_Exp> | null | undefined;
  content?: String_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deleted?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  modified_date?: Timestamptz_Comparison_Exp | null | undefined;
  order_reference_id?: Uuid_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  type?: String_Comparison_Exp | null | undefined;
  user_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "comment_history" */
export type Comment_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'comment_history_pkey';

/** input type for inserting data into table "comment_history" */
export type Comment_History_Insert_Input = {
  content?: string | null | undefined;
  created_date?: string | null | undefined;
  deleted?: boolean | null | undefined;
  id?: string | null | undefined;
  modified_date?: string | null | undefined;
  order_reference_id?: string | null | undefined;
  reference_id?: string | null | undefined;
  type?: string | null | undefined;
  user_id?: string | null | undefined;
};

/** on_conflict condition type for table "comment_history" */
export type Comment_History_On_Conflict = {
  constraint: Comment_History_Constraint;
  update_columns?: Array<Comment_History_Update_Column>;
  where?: Comment_History_Bool_Exp | null | undefined;
};

/** select columns of table "comment_history" */
export type Comment_History_Select_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted'
  /** column name */
  | 'id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'order_reference_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'type'
  /** column name */
  | 'user_id';

/** select "comment_history_aggregate_bool_exp_bool_and_arguments_columns" columns of table "comment_history" */
export type Comment_History_Select_Column_Comment_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'deleted';

/** select "comment_history_aggregate_bool_exp_bool_or_arguments_columns" columns of table "comment_history" */
export type Comment_History_Select_Column_Comment_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'deleted';

/** update columns of table "comment_history" */
export type Comment_History_Update_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted'
  /** column name */
  | 'id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'order_reference_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'type'
  /** column name */
  | 'user_id';

/** input type for inserting data into table "comment" */
export type Comment_Insert_Input = {
  attachments?: Document_Arr_Rel_Insert_Input | null | undefined;
  content?: string | null | undefined;
  created_date?: string | null | undefined;
  deleted?: boolean | null | undefined;
  id?: string | null | undefined;
  modified_date?: string | null | undefined;
  order?: Order_Obj_Rel_Insert_Input | null | undefined;
  order_reference_id?: string | null | undefined;
  reference_id?: string | null | undefined;
  type?: Comment_Type_Enum | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
  user_id?: string | null | undefined;
};

/** on_conflict condition type for table "comment" */
export type Comment_On_Conflict = {
  constraint: Comment_Constraint;
  update_columns?: Array<Comment_Update_Column>;
  where?: Comment_Bool_Exp | null | undefined;
};

/** select columns of table "comment" */
export type Comment_Select_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted'
  /** column name */
  | 'id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'order_reference_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'type'
  /** column name */
  | 'user_id';

/** select "comment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "comment" */
export type Comment_Select_Column_Comment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'deleted';

/** select "comment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "comment" */
export type Comment_Select_Column_Comment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'deleted';

export type Comment_Type_Enum =
  /** comment to specify order cancellation reason */
  | 'CANCEL_REASON'
  /** default comment */
  | 'DEFAULT'
  /** comment added in order creation */
  | 'ORDER_CREATION';

/** Boolean expression to compare columns of type "comment_type_enum". All fields are combined with logical 'AND'. */
export type Comment_Type_Enum_Comparison_Exp = {
  _eq?: Comment_Type_Enum | null | undefined;
  _in?: Array<Comment_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Comment_Type_Enum | null | undefined;
  _nin?: Array<Comment_Type_Enum> | null | undefined;
};

/** update columns of table "comment" */
export type Comment_Update_Column =
  /** column name */
  | 'content'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted'
  /** column name */
  | 'id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'order_reference_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'type'
  /** column name */
  | 'user_id';

/** Boolean expression to filter rows from the table "commission". All fields are combined with a logical 'AND'. */
export type Commission_Bool_Exp = {
  _and?: Array<Commission_Bool_Exp> | null | undefined;
  _not?: Commission_Bool_Exp | null | undefined;
  _or?: Array<Commission_Bool_Exp> | null | undefined;
  type?: Commission_Type_Enum_Comparison_Exp | null | undefined;
  value?: Numeric_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "commission" */
export type Commission_Constraint =
  /** unique or primary key constraint on columns "type" */
  | 'commission_pkey';

/** input type for inserting data into table "commission" */
export type Commission_Insert_Input = {
  type?: Commission_Type_Enum | null | undefined;
  value?: number | null | undefined;
};

/** input type for inserting object relation for remote table "commission" */
export type Commission_Obj_Rel_Insert_Input = {
  data: Commission_Insert_Input;
  /** upsert condition */
  on_conflict?: Commission_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "commission" */
export type Commission_On_Conflict = {
  constraint: Commission_Constraint;
  update_columns?: Array<Commission_Update_Column>;
  where?: Commission_Bool_Exp | null | undefined;
};

export type Commission_Type_Enum =
  | 'CUSTOM'
  | 'NO_COMMISSION'
  /** 5% commission on order value */
  | 'STANDARD_5_PERCENT'
  /** 10% commission on order value */
  | 'STANDARD_10_PERCENT';

/** Boolean expression to compare columns of type "commission_type_enum". All fields are combined with logical 'AND'. */
export type Commission_Type_Enum_Comparison_Exp = {
  _eq?: Commission_Type_Enum | null | undefined;
  _in?: Array<Commission_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Commission_Type_Enum | null | undefined;
  _nin?: Array<Commission_Type_Enum> | null | undefined;
};

/** update columns of table "commission" */
export type Commission_Update_Column =
  /** column name */
  | 'type'
  /** column name */
  | 'value';

/** Boolean expression to filter rows from the table "company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp = {
  _and?: Array<Company_Bool_Exp> | null | undefined;
  _not?: Company_Bool_Exp | null | undefined;
  _or?: Array<Company_Bool_Exp> | null | undefined;
  addresses?: Address_Bool_Exp | null | undefined;
  addresses_aggregate?: Address_Aggregate_Bool_Exp | null | undefined;
  animation_details?: String_Comparison_Exp | null | undefined;
  brand?: Brand_Enum_Comparison_Exp | null | undefined;
  business_profile?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  buying_contracts?: Contract_Bool_Exp | null | undefined;
  buying_contracts_aggregate?: Contract_Aggregate_Bool_Exp | null | undefined;
  commission?: Commission_Bool_Exp | null | undefined;
  contactEmail?: Citext_Comparison_Exp | null | undefined;
  contactPhoneNumber?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  days_before_auto_reception?: Numeric_Comparison_Exp | null | undefined;
  default_commission_type?: Commission_Type_Enum_Comparison_Exp | null | undefined;
  default_custom_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  default_payment_method?: Payment_Method_Enum_Comparison_Exp | null | undefined;
  delivery_address?: Additional_Address_Bool_Exp | null | undefined;
  delivery_address_id?: Uuid_Comparison_Exp | null | undefined;
  delivery_description?: String_Comparison_Exp | null | undefined;
  delivery_email?: Citext_Comparison_Exp | null | undefined;
  delivery_hours?: Delivery_Hours_Bool_Exp | null | undefined;
  delivery_hours_aggregate?: Delivery_Hours_Aggregate_Bool_Exp | null | undefined;
  delivery_instructions?: String_Comparison_Exp | null | undefined;
  delivery_phone_number?: String_Comparison_Exp | null | undefined;
  delivery_zones?: Delivery_Zone_Bool_Exp | null | undefined;
  delivery_zones_aggregate?: Delivery_Zone_Aggregate_Bool_Exp | null | undefined;
  description?: String_Comparison_Exp | null | undefined;
  edi_connection_name?: String_Comparison_Exp | null | undefined;
  edi_endpoint?: String_Comparison_Exp | null | undefined;
  electrical_appliance_details?: String_Comparison_Exp | null | undefined;
  enable_invoice_generation?: Boolean_Comparison_Exp | null | undefined;
  gln?: String_Comparison_Exp | null | undefined;
  iban?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  invoice_prefix?: String_Comparison_Exp | null | undefined;
  invoicing_address?: Additional_Address_Bool_Exp | null | undefined;
  invoicing_address_id?: Uuid_Comparison_Exp | null | undefined;
  invoicing_email?: Citext_Comparison_Exp | null | undefined;
  invoicing_instructions?: String_Comparison_Exp | null | undefined;
  invoicing_phone_number?: String_Comparison_Exp | null | undefined;
  is_allowed_to_sponsor_company?: Boolean_Comparison_Exp | null | undefined;
  is_client?: Boolean_Comparison_Exp | null | undefined;
  is_subject_to_vat?: Boolean_Comparison_Exp | null | undefined;
  is_visible_in_discovery?: Boolean_Comparison_Exp | null | undefined;
  is_wholesaler?: Boolean_Comparison_Exp | null | undefined;
  legalName?: String_Comparison_Exp | null | undefined;
  lemonway_default_sdd_mandate_id?: Int_Comparison_Exp | null | undefined;
  lemonway_iban_id?: Int_Comparison_Exp | null | undefined;
  marketing_details?: String_Comparison_Exp | null | undefined;
  marketing_supports?: Company_Marketing_Support_Bool_Exp | null | undefined;
  marketing_supports_aggregate?: Company_Marketing_Support_Aggregate_Bool_Exp | null | undefined;
  merchandising_details?: String_Comparison_Exp | null | undefined;
  national_company_registration_number?: String_Comparison_Exp | null | undefined;
  packagings?: Packaging_Bool_Exp | null | undefined;
  packagings_aggregate?: Packaging_Aggregate_Bool_Exp | null | undefined;
  photos?: Company_Photo_Bool_Exp | null | undefined;
  photos_aggregate?: Company_Photo_Aggregate_Bool_Exp | null | undefined;
  products?: Product_Bool_Exp | null | undefined;
  products_aggregate?: Product_Aggregate_Bool_Exp | null | undefined;
  provide_animation?: Boolean_Comparison_Exp | null | undefined;
  provide_electrical_appliance?: Boolean_Comparison_Exp | null | undefined;
  provide_marketing?: Boolean_Comparison_Exp | null | undefined;
  provide_merchandising?: Boolean_Comparison_Exp | null | undefined;
  provide_return_policy?: Boolean_Comparison_Exp | null | undefined;
  return_policy?: Return_Policy_Enum_Comparison_Exp | null | undefined;
  return_policy_details?: String_Comparison_Exp | null | undefined;
  role_assignments?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignments_aggregate?: Role_Assignment_Aggregate_Bool_Exp | null | undefined;
  social_tags?: Social_Tag_Bool_Exp | null | undefined;
  social_tags_aggregate?: Social_Tag_Aggregate_Bool_Exp | null | undefined;
  sponsored_by?: Uuid_Comparison_Exp | null | undefined;
  supplier_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  supplying_contracts?: Contract_Bool_Exp | null | undefined;
  supplying_contracts_aggregate?: Contract_Aggregate_Bool_Exp | null | undefined;
  tradeName?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "company" */
export type Company_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_056f7854a7afdba7cbd6d45fc20'
  /** unique or primary key constraint on columns "invoice_prefix" */
  | 'company_invoice_prefix_key'
  /** unique or primary key constraint on columns "lemonway_iban_id" */
  | 'company_lemonway_iban_id_key'
  /** unique or primary key constraint on columns "national_company_registration_number" */
  | 'uq_company_national_company_registration_number';

/** input type for inserting data into table "company" */
export type Company_Insert_Input = {
  addresses?: Address_Arr_Rel_Insert_Input | null | undefined;
  animation_details?: string | null | undefined;
  brand?: Brand_Enum | null | undefined;
  business_profile?: Business_Profile_Enum | null | undefined;
  buying_contracts?: Contract_Arr_Rel_Insert_Input | null | undefined;
  commission?: Commission_Obj_Rel_Insert_Input | null | undefined;
  contactEmail?: string | null | undefined;
  contactPhoneNumber?: string | null | undefined;
  created_at?: string | null | undefined;
  days_before_auto_reception?: number | null | undefined;
  default_commission_type?: Commission_Type_Enum | null | undefined;
  default_custom_commission_rate?: number | null | undefined;
  default_payment_method?: Payment_Method_Enum | null | undefined;
  delivery_address?: Additional_Address_Obj_Rel_Insert_Input | null | undefined;
  delivery_address_id?: string | null | undefined;
  delivery_description?: string | null | undefined;
  delivery_email?: string | null | undefined;
  delivery_hours?: Delivery_Hours_Arr_Rel_Insert_Input | null | undefined;
  delivery_instructions?: string | null | undefined;
  delivery_phone_number?: string | null | undefined;
  delivery_zones?: Delivery_Zone_Arr_Rel_Insert_Input | null | undefined;
  description?: string | null | undefined;
  edi_connection_name?: string | null | undefined;
  edi_endpoint?: string | null | undefined;
  electrical_appliance_details?: string | null | undefined;
  enable_invoice_generation?: boolean | null | undefined;
  gln?: string | null | undefined;
  iban?: string | null | undefined;
  id?: string | null | undefined;
  invoice_prefix?: string | null | undefined;
  invoicing_address?: Additional_Address_Obj_Rel_Insert_Input | null | undefined;
  invoicing_address_id?: string | null | undefined;
  invoicing_email?: string | null | undefined;
  invoicing_instructions?: string | null | undefined;
  invoicing_phone_number?: string | null | undefined;
  is_allowed_to_sponsor_company?: boolean | null | undefined;
  is_client?: boolean | null | undefined;
  is_subject_to_vat?: boolean | null | undefined;
  is_visible_in_discovery?: boolean | null | undefined;
  is_wholesaler?: boolean | null | undefined;
  legalName?: string | null | undefined;
  lemonway_default_sdd_mandate_id?: number | null | undefined;
  lemonway_iban_id?: number | null | undefined;
  marketing_details?: string | null | undefined;
  marketing_supports?: Company_Marketing_Support_Arr_Rel_Insert_Input | null | undefined;
  merchandising_details?: string | null | undefined;
  national_company_registration_number?: string | null | undefined;
  packagings?: Packaging_Arr_Rel_Insert_Input | null | undefined;
  photos?: Company_Photo_Arr_Rel_Insert_Input | null | undefined;
  products?: Product_Arr_Rel_Insert_Input | null | undefined;
  provide_animation?: boolean | null | undefined;
  provide_electrical_appliance?: boolean | null | undefined;
  provide_marketing?: boolean | null | undefined;
  provide_merchandising?: boolean | null | undefined;
  provide_return_policy?: boolean | null | undefined;
  return_policy?: Return_Policy_Enum | null | undefined;
  return_policy_details?: string | null | undefined;
  role_assignments?: Role_Assignment_Arr_Rel_Insert_Input | null | undefined;
  social_tags?: Social_Tag_Arr_Rel_Insert_Input | null | undefined;
  sponsored_by?: string | null | undefined;
  supplying_contracts?: Contract_Arr_Rel_Insert_Input | null | undefined;
  tradeName?: string | null | undefined;
  updated_at?: string | null | undefined;
};

export type Company_Marketing_Support_Aggregate_Bool_Exp = {
  count?: Company_Marketing_Support_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Company_Marketing_Support_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Company_Marketing_Support_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Company_Marketing_Support_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "company_marketing_support" */
export type Company_Marketing_Support_Arr_Rel_Insert_Input = {
  data: Array<Company_Marketing_Support_Insert_Input>;
  /** upsert condition */
  on_conflict?: Company_Marketing_Support_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "company_marketing_support". All fields are combined with a logical 'AND'. */
export type Company_Marketing_Support_Bool_Exp = {
  _and?: Array<Company_Marketing_Support_Bool_Exp> | null | undefined;
  _not?: Company_Marketing_Support_Bool_Exp | null | undefined;
  _or?: Array<Company_Marketing_Support_Bool_Exp> | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  support?: Marketing_Support_Enum_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "company_marketing_support" */
export type Company_Marketing_Support_Constraint =
  /** unique or primary key constraint on columns "support", "company_id" */
  | 'company_marketing_support_company_id_support_key'
  /** unique or primary key constraint on columns "id" */
  | 'company_marketing_support_pkey';

/** input type for inserting data into table "company_marketing_support" */
export type Company_Marketing_Support_Insert_Input = {
  company_id?: string | null | undefined;
  id?: string | null | undefined;
  support?: Marketing_Support_Enum | null | undefined;
};

/** on_conflict condition type for table "company_marketing_support" */
export type Company_Marketing_Support_On_Conflict = {
  constraint: Company_Marketing_Support_Constraint;
  update_columns?: Array<Company_Marketing_Support_Update_Column>;
  where?: Company_Marketing_Support_Bool_Exp | null | undefined;
};

/** select columns of table "company_marketing_support" */
export type Company_Marketing_Support_Select_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'support';

/** update columns of table "company_marketing_support" */
export type Company_Marketing_Support_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'support';

/** input type for inserting object relation for remote table "company" */
export type Company_Obj_Rel_Insert_Input = {
  data: Company_Insert_Input;
  /** upsert condition */
  on_conflict?: Company_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "company" */
export type Company_On_Conflict = {
  constraint: Company_Constraint;
  update_columns?: Array<Company_Update_Column>;
  where?: Company_Bool_Exp | null | undefined;
};

export type Company_Photo_Aggregate_Bool_Exp = {
  count?: Company_Photo_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Company_Photo_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Company_Photo_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Company_Photo_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "company_photo" */
export type Company_Photo_Arr_Rel_Insert_Input = {
  data: Array<Company_Photo_Insert_Input>;
  /** upsert condition */
  on_conflict?: Company_Photo_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "company_photo". All fields are combined with a logical 'AND'. */
export type Company_Photo_Bool_Exp = {
  _and?: Array<Company_Photo_Bool_Exp> | null | undefined;
  _not?: Company_Photo_Bool_Exp | null | undefined;
  _or?: Array<Company_Photo_Bool_Exp> | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  photo?: Photo_Bool_Exp | null | undefined;
  photo_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "company_photo" */
export type Company_Photo_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'company_photo_pkey';

/** input type for inserting data into table "company_photo" */
export type Company_Photo_Insert_Input = {
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  photo?: Photo_Obj_Rel_Insert_Input | null | undefined;
  photo_id?: string | null | undefined;
};

/** on_conflict condition type for table "company_photo" */
export type Company_Photo_On_Conflict = {
  constraint: Company_Photo_Constraint;
  update_columns?: Array<Company_Photo_Update_Column>;
  where?: Company_Photo_Bool_Exp | null | undefined;
};

/** select columns of table "company_photo" */
export type Company_Photo_Select_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** update columns of table "company_photo" */
export type Company_Photo_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'photo_id';

/** update columns of table "company" */
export type Company_Update_Column =
  /** column name */
  | 'animation_details'
  /** column name */
  | 'brand'
  /** column name */
  | 'business_profile'
  /** column name */
  | 'contactEmail'
  /** column name */
  | 'contactPhoneNumber'
  /** column name */
  | 'created_at'
  /** column name */
  | 'days_before_auto_reception'
  /** column name */
  | 'default_commission_type'
  /** column name */
  | 'default_custom_commission_rate'
  /** column name */
  | 'default_payment_method'
  /** column name */
  | 'delivery_address_id'
  /** column name */
  | 'delivery_description'
  /** column name */
  | 'delivery_email'
  /** column name */
  | 'delivery_instructions'
  /** column name */
  | 'delivery_phone_number'
  /** column name */
  | 'description'
  /** column name */
  | 'edi_connection_name'
  /** column name */
  | 'edi_endpoint'
  /** column name */
  | 'electrical_appliance_details'
  /** column name */
  | 'enable_invoice_generation'
  /** column name */
  | 'gln'
  /** column name */
  | 'iban'
  /** column name */
  | 'id'
  /** column name */
  | 'invoice_prefix'
  /** column name */
  | 'invoicing_address_id'
  /** column name */
  | 'invoicing_email'
  /** column name */
  | 'invoicing_instructions'
  /** column name */
  | 'invoicing_phone_number'
  /** column name */
  | 'is_allowed_to_sponsor_company'
  /** column name */
  | 'is_client'
  /** column name */
  | 'is_subject_to_vat'
  /** column name */
  | 'is_visible_in_discovery'
  /** column name */
  | 'is_wholesaler'
  /** column name */
  | 'legalName'
  /** column name */
  | 'lemonway_default_sdd_mandate_id'
  /** column name */
  | 'lemonway_iban_id'
  /** column name */
  | 'marketing_details'
  /** column name */
  | 'merchandising_details'
  /** column name */
  | 'national_company_registration_number'
  /** column name */
  | 'provide_animation'
  /** column name */
  | 'provide_electrical_appliance'
  /** column name */
  | 'provide_marketing'
  /** column name */
  | 'provide_merchandising'
  /** column name */
  | 'provide_return_policy'
  /** column name */
  | 'return_policy'
  /** column name */
  | 'return_policy_details'
  /** column name */
  | 'sponsored_by'
  /** column name */
  | 'tradeName'
  /** column name */
  | 'updated_at';

export type Contract_Aggregate_Bool_Exp = {
  bool_and?: Contract_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Contract_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Contract_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Contract_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contract_Select_Column_Contract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Contract_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Contract_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contract_Select_Column_Contract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Contract_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Contract_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Contract_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Contract_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "contract" */
export type Contract_Arr_Rel_Insert_Input = {
  data: Array<Contract_Insert_Input>;
  /** upsert condition */
  on_conflict?: Contract_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "contract". All fields are combined with a logical 'AND'. */
export type Contract_Bool_Exp = {
  _and?: Array<Contract_Bool_Exp> | null | undefined;
  _not?: Contract_Bool_Exp | null | undefined;
  _or?: Array<Contract_Bool_Exp> | null | undefined;
  buyingCompanyId?: Uuid_Comparison_Exp | null | undefined;
  buying_company?: Company_Bool_Exp | null | undefined;
  catalog?: Catalog_Bool_Exp | null | undefined;
  catalog_id?: Uuid_Comparison_Exp | null | undefined;
  channel_url?: String_Comparison_Exp | null | undefined;
  commission?: Commission_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list?: Custom_Price_List_Bool_Exp | null | undefined;
  custom_price_list_id?: Uuid_Comparison_Exp | null | undefined;
  custom_sdd_payment_delay?: Int_Comparison_Exp | null | undefined;
  discount?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  introduced_by_kheops?: Boolean_Comparison_Exp | null | undefined;
  is_trusted_supplier?: Boolean_Comparison_Exp | null | undefined;
  last_order_date?: Timestamptz_Comparison_Exp | null | undefined;
  minimum_order_value?: Numeric_Comparison_Exp | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum_Comparison_Exp | null | undefined;
  order_count?: Numeric_Comparison_Exp | null | undefined;
  payment_method?: Payment_Method_Enum_Comparison_Exp | null | undefined;
  proposer?: User_Bool_Exp | null | undefined;
  proposer_business_profile?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  proposer_user_id?: Uuid_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  status?: Contract_Status_Enum_Comparison_Exp | null | undefined;
  sub_catalog?: Sub_Catalog_Bool_Exp | null | undefined;
  sub_catalog_id?: Uuid_Comparison_Exp | null | undefined;
  supplier_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  supplier_commission_type?: Commission_Type_Enum_Comparison_Exp | null | undefined;
  supplier_custom_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  supplyingCompanyId?: Uuid_Comparison_Exp | null | undefined;
  supplying_company?: Company_Bool_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "contract" */
export type Contract_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_17c3a89f58a2997276084e706e8'
  /** unique or primary key constraint on columns "supplyingCompanyId", "buyingCompanyId" */
  | 'contract_buyingCompanyId_supplyingCompanyId_key'
  /** unique or primary key constraint on columns "channel_url" */
  | 'contract_channel_url_key'
  /** unique or primary key constraint on columns "reference_id" */
  | 'contract_reference_id_key';

export type Contract_History_Aggregate_Bool_Exp = {
  bool_and?: Contract_History_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Contract_History_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Contract_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Contract_History_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contract_History_Select_Column_Contract_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Contract_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Contract_History_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contract_History_Select_Column_Contract_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Contract_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Contract_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Contract_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Contract_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "contract_history" */
export type Contract_History_Arr_Rel_Insert_Input = {
  data: Array<Contract_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Contract_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "contract_history". All fields are combined with a logical 'AND'. */
export type Contract_History_Bool_Exp = {
  _and?: Array<Contract_History_Bool_Exp> | null | undefined;
  _not?: Contract_History_Bool_Exp | null | undefined;
  _or?: Array<Contract_History_Bool_Exp> | null | undefined;
  buyingCompanyId?: Uuid_Comparison_Exp | null | undefined;
  buying_company?: Company_Bool_Exp | null | undefined;
  catalog?: Catalog_Bool_Exp | null | undefined;
  catalog_id?: Uuid_Comparison_Exp | null | undefined;
  channel_url?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list?: Custom_Price_List_History_Bool_Exp | null | undefined;
  custom_price_list_id?: Uuid_Comparison_Exp | null | undefined;
  custom_sdd_payment_delay?: Int_Comparison_Exp | null | undefined;
  discount?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  introduced_by_kheops?: Boolean_Comparison_Exp | null | undefined;
  is_trusted_supplier?: Boolean_Comparison_Exp | null | undefined;
  minimum_order_value?: Numeric_Comparison_Exp | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum_Comparison_Exp | null | undefined;
  orders?: Order_Bool_Exp | null | undefined;
  orders_aggregate?: Order_Aggregate_Bool_Exp | null | undefined;
  payment_method?: String_Comparison_Exp | null | undefined;
  proposer_business_profile?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  proposer_user_id?: Uuid_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  status?: Contract_Status_Enum_Comparison_Exp | null | undefined;
  sub_catalog_id?: Uuid_Comparison_Exp | null | undefined;
  supplier_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  supplier_commission_type?: Commission_Type_Enum_Comparison_Exp | null | undefined;
  supplier_custom_commission_rate?: Numeric_Comparison_Exp | null | undefined;
  supplyingCompanyId?: Uuid_Comparison_Exp | null | undefined;
  supplying_company?: Company_Bool_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "contract_history" */
export type Contract_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'contract_history_pkey';

/** input type for inserting data into table "contract_history" */
export type Contract_History_Insert_Input = {
  buyingCompanyId?: string | null | undefined;
  buying_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  catalog?: Catalog_Obj_Rel_Insert_Input | null | undefined;
  catalog_id?: string | null | undefined;
  channel_url?: string | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list?: Custom_Price_List_History_Obj_Rel_Insert_Input | null | undefined;
  custom_price_list_id?: string | null | undefined;
  custom_sdd_payment_delay?: number | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  introduced_by_kheops?: boolean | null | undefined;
  is_trusted_supplier?: boolean | null | undefined;
  minimum_order_value?: number | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum | null | undefined;
  orders?: Order_Arr_Rel_Insert_Input | null | undefined;
  payment_method?: string | null | undefined;
  proposer_business_profile?: Business_Profile_Enum | null | undefined;
  proposer_user_id?: string | null | undefined;
  reference_id?: string | null | undefined;
  status?: Contract_Status_Enum | null | undefined;
  sub_catalog_id?: string | null | undefined;
  supplier_commission_type?: Commission_Type_Enum | null | undefined;
  supplier_custom_commission_rate?: number | null | undefined;
  supplyingCompanyId?: string | null | undefined;
  supplying_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
};

/** input type for inserting object relation for remote table "contract_history" */
export type Contract_History_Obj_Rel_Insert_Input = {
  data: Contract_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Contract_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "contract_history" */
export type Contract_History_On_Conflict = {
  constraint: Contract_History_Constraint;
  update_columns?: Array<Contract_History_Update_Column>;
  where?: Contract_History_Bool_Exp | null | undefined;
};

/** select columns of table "contract_history" */
export type Contract_History_Select_Column =
  /** column name */
  | 'buyingCompanyId'
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'channel_url'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'custom_sdd_payment_delay'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'proposer_business_profile'
  /** column name */
  | 'proposer_user_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'status'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_commission_type'
  /** column name */
  | 'supplier_custom_commission_rate'
  /** column name */
  | 'supplyingCompanyId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** select "contract_history_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contract_history" */
export type Contract_History_Select_Column_Contract_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier';

/** select "contract_history_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contract_history" */
export type Contract_History_Select_Column_Contract_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier';

/** update columns of table "contract_history" */
export type Contract_History_Update_Column =
  /** column name */
  | 'buyingCompanyId'
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'channel_url'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'custom_sdd_payment_delay'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'proposer_business_profile'
  /** column name */
  | 'proposer_user_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'status'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_commission_type'
  /** column name */
  | 'supplier_custom_commission_rate'
  /** column name */
  | 'supplyingCompanyId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for inserting data into table "contract" */
export type Contract_Insert_Input = {
  buyingCompanyId?: string | null | undefined;
  buying_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  catalog?: Catalog_Obj_Rel_Insert_Input | null | undefined;
  catalog_id?: string | null | undefined;
  channel_url?: string | null | undefined;
  commission?: Commission_Obj_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list?: Custom_Price_List_Obj_Rel_Insert_Input | null | undefined;
  custom_price_list_id?: string | null | undefined;
  custom_sdd_payment_delay?: number | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  introduced_by_kheops?: boolean | null | undefined;
  is_trusted_supplier?: boolean | null | undefined;
  minimum_order_value?: number | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum | null | undefined;
  payment_method?: Payment_Method_Enum | null | undefined;
  proposer?: User_Obj_Rel_Insert_Input | null | undefined;
  proposer_business_profile?: Business_Profile_Enum | null | undefined;
  proposer_user_id?: string | null | undefined;
  reference_id?: string | null | undefined;
  status?: Contract_Status_Enum | null | undefined;
  sub_catalog?: Sub_Catalog_Obj_Rel_Insert_Input | null | undefined;
  sub_catalog_id?: string | null | undefined;
  /** Non-nullable is only applied by supplier_commission_type_constraint */
  supplier_commission_type?: Commission_Type_Enum | null | undefined;
  supplier_custom_commission_rate?: number | null | undefined;
  supplyingCompanyId?: string | null | undefined;
  supplying_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
};

/** input type for inserting object relation for remote table "contract" */
export type Contract_Obj_Rel_Insert_Input = {
  data: Contract_Insert_Input;
  /** upsert condition */
  on_conflict?: Contract_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "contract" */
export type Contract_On_Conflict = {
  constraint: Contract_Constraint;
  update_columns?: Array<Contract_Update_Column>;
  where?: Contract_Bool_Exp | null | undefined;
};

/** select columns of table "contract" */
export type Contract_Select_Column =
  /** column name */
  | 'buyingCompanyId'
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'channel_url'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'custom_sdd_payment_delay'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'proposer_business_profile'
  /** column name */
  | 'proposer_user_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'status'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_commission_type'
  /** column name */
  | 'supplier_custom_commission_rate'
  /** column name */
  | 'supplyingCompanyId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** select "contract_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contract" */
export type Contract_Select_Column_Contract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier';

/** select "contract_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contract" */
export type Contract_Select_Column_Contract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier';

export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

/** Boolean expression to compare columns of type "contract_status_enum". All fields are combined with logical 'AND'. */
export type Contract_Status_Enum_Comparison_Exp = {
  _eq?: Contract_Status_Enum | null | undefined;
  _in?: Array<Contract_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Contract_Status_Enum | null | undefined;
  _nin?: Array<Contract_Status_Enum> | null | undefined;
};

/** update columns of table "contract" */
export type Contract_Update_Column =
  /** column name */
  | 'buyingCompanyId'
  /** column name */
  | 'catalog_id'
  /** column name */
  | 'channel_url'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'custom_sdd_payment_delay'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'introduced_by_kheops'
  /** column name */
  | 'is_trusted_supplier'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'proposer_business_profile'
  /** column name */
  | 'proposer_user_id'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'status'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_commission_type'
  /** column name */
  | 'supplier_custom_commission_rate'
  /** column name */
  | 'supplyingCompanyId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** Boolean expression to filter rows from the table "custom_price_list". All fields are combined with a logical 'AND'. */
export type Custom_Price_List_Bool_Exp = {
  _and?: Array<Custom_Price_List_Bool_Exp> | null | undefined;
  _not?: Custom_Price_List_Bool_Exp | null | undefined;
  _or?: Array<Custom_Price_List_Bool_Exp> | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  contracts?: Contract_Bool_Exp | null | undefined;
  contracts_aggregate?: Contract_Aggregate_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list_packagings?: Custom_Price_List_Packaging_Bool_Exp | null | undefined;
  custom_price_list_packagings_aggregate?: Custom_Price_List_Packaging_Aggregate_Bool_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "custom_price_list" */
export type Custom_Price_List_Constraint =
  /** unique or primary key constraint on columns "name", "company_id" */
  | 'custom_price_list_name_company_id_uq'
  /** unique or primary key constraint on columns "id" */
  | 'custom_price_list_pkey'
  /** unique or primary key constraint on columns "reference_id" */
  | 'custom_price_list_reference_id_key';

/** Boolean expression to filter rows from the table "custom_price_list_history". All fields are combined with a logical 'AND'. */
export type Custom_Price_List_History_Bool_Exp = {
  _and?: Array<Custom_Price_List_History_Bool_Exp> | null | undefined;
  _not?: Custom_Price_List_History_Bool_Exp | null | undefined;
  _or?: Array<Custom_Price_List_History_Bool_Exp> | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  contracts?: Contract_History_Bool_Exp | null | undefined;
  contracts_aggregate?: Contract_History_Aggregate_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list_packagings?: Custom_Price_List_Packaging_History_Bool_Exp | null | undefined;
  custom_price_list_packagings_aggregate?: Custom_Price_List_Packaging_History_Aggregate_Bool_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "custom_price_list_history" */
export type Custom_Price_List_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'custom_price_list_history_pkey';

/** input type for inserting data into table "custom_price_list_history" */
export type Custom_Price_List_History_Insert_Input = {
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  contracts?: Contract_History_Arr_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list_packagings?: Custom_Price_List_Packaging_History_Arr_Rel_Insert_Input | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  reference_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "custom_price_list_history" */
export type Custom_Price_List_History_Obj_Rel_Insert_Input = {
  data: Custom_Price_List_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Custom_Price_List_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "custom_price_list_history" */
export type Custom_Price_List_History_On_Conflict = {
  constraint: Custom_Price_List_History_Constraint;
  update_columns?: Array<Custom_Price_List_History_Update_Column>;
  where?: Custom_Price_List_History_Bool_Exp | null | undefined;
};

/** update columns of table "custom_price_list_history" */
export type Custom_Price_List_History_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'updated_at';

/** input type for inserting data into table "custom_price_list" */
export type Custom_Price_List_Insert_Input = {
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  contracts?: Contract_Arr_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list_packagings?: Custom_Price_List_Packaging_Arr_Rel_Insert_Input | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  reference_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "custom_price_list" */
export type Custom_Price_List_Obj_Rel_Insert_Input = {
  data: Custom_Price_List_Insert_Input;
  /** upsert condition */
  on_conflict?: Custom_Price_List_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "custom_price_list" */
export type Custom_Price_List_On_Conflict = {
  constraint: Custom_Price_List_Constraint;
  update_columns?: Array<Custom_Price_List_Update_Column>;
  where?: Custom_Price_List_Bool_Exp | null | undefined;
};

export type Custom_Price_List_Packaging_Aggregate_Bool_Exp = {
  count?: Custom_Price_List_Packaging_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Custom_Price_List_Packaging_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Custom_Price_List_Packaging_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Custom_Price_List_Packaging_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_Arr_Rel_Insert_Input = {
  data: Array<Custom_Price_List_Packaging_Insert_Input>;
  /** upsert condition */
  on_conflict?: Custom_Price_List_Packaging_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "custom_price_list_packaging". All fields are combined with a logical 'AND'. */
export type Custom_Price_List_Packaging_Bool_Exp = {
  _and?: Array<Custom_Price_List_Packaging_Bool_Exp> | null | undefined;
  _not?: Custom_Price_List_Packaging_Bool_Exp | null | undefined;
  _or?: Array<Custom_Price_List_Packaging_Bool_Exp> | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list?: Custom_Price_List_Bool_Exp | null | undefined;
  custom_price_list_id?: Uuid_Comparison_Exp | null | undefined;
  discount?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  packaging?: Packaging_Bool_Exp | null | undefined;
  packaging_sku?: Int_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_Constraint =
  /** unique or primary key constraint on columns "packaging_sku", "custom_price_list_id", "company_id" */
  | 'custom_price_list_packaging_packaging_sku_company_id_custom_pri'
  /** unique or primary key constraint on columns "id" */
  | 'custom_price_list_packaging_pkey';

export type Custom_Price_List_Packaging_History_Aggregate_Bool_Exp = {
  count?: Custom_Price_List_Packaging_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Custom_Price_List_Packaging_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Custom_Price_List_Packaging_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Custom_Price_List_Packaging_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_Arr_Rel_Insert_Input = {
  data: Array<Custom_Price_List_Packaging_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Custom_Price_List_Packaging_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "custom_price_list_packaging_history". All fields are combined with a logical 'AND'. */
export type Custom_Price_List_Packaging_History_Bool_Exp = {
  _and?: Array<Custom_Price_List_Packaging_History_Bool_Exp> | null | undefined;
  _not?: Custom_Price_List_Packaging_History_Bool_Exp | null | undefined;
  _or?: Array<Custom_Price_List_Packaging_History_Bool_Exp> | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  custom_price_list_id?: Uuid_Comparison_Exp | null | undefined;
  discount?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  packaging_sku?: Int_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'custom_price_list_packaging_history_pkey';

/** input type for inserting data into table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_Insert_Input = {
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list_id?: string | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  packaging_sku?: number | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_On_Conflict = {
  constraint: Custom_Price_List_Packaging_History_Constraint;
  update_columns?: Array<Custom_Price_List_Packaging_History_Update_Column>;
  where?: Custom_Price_List_Packaging_History_Bool_Exp | null | undefined;
};

/** select columns of table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_Select_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** update columns of table "custom_price_list_packaging_history" */
export type Custom_Price_List_Packaging_History_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** input type for inserting data into table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_Insert_Input = {
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  custom_price_list?: Custom_Price_List_Obj_Rel_Insert_Input | null | undefined;
  custom_price_list_id?: string | null | undefined;
  discount?: number | null | undefined;
  id?: string | null | undefined;
  packaging?: Packaging_Obj_Rel_Insert_Input | null | undefined;
  packaging_sku?: number | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_On_Conflict = {
  constraint: Custom_Price_List_Packaging_Constraint;
  update_columns?: Array<Custom_Price_List_Packaging_Update_Column>;
  where?: Custom_Price_List_Packaging_Bool_Exp | null | undefined;
};

/** select columns of table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_Select_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** update columns of table "custom_price_list_packaging" */
export type Custom_Price_List_Packaging_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'custom_price_list_id'
  /** column name */
  | 'discount'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'updated_at';

/** update columns of table "custom_price_list" */
export type Custom_Price_List_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'updated_at';

export type Delivery_Hours_Aggregate_Bool_Exp = {
  count?: Delivery_Hours_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Delivery_Hours_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Delivery_Hours_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Delivery_Hours_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "delivery_hours" */
export type Delivery_Hours_Arr_Rel_Insert_Input = {
  data: Array<Delivery_Hours_Insert_Input>;
  /** upsert condition */
  on_conflict?: Delivery_Hours_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "delivery_hours". All fields are combined with a logical 'AND'. */
export type Delivery_Hours_Bool_Exp = {
  _and?: Array<Delivery_Hours_Bool_Exp> | null | undefined;
  _not?: Delivery_Hours_Bool_Exp | null | undefined;
  _or?: Array<Delivery_Hours_Bool_Exp> | null | undefined;
  closing_hour?: Timetz_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  opening_hour?: Timetz_Comparison_Exp | null | undefined;
  week_day?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "delivery_hours" */
export type Delivery_Hours_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'delivery_hours_pkey';

/** input type for inserting data into table "delivery_hours" */
export type Delivery_Hours_Insert_Input = {
  closing_hour?: string | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  id?: string | null | undefined;
  opening_hour?: string | null | undefined;
  week_day?: string | null | undefined;
};

/** on_conflict condition type for table "delivery_hours" */
export type Delivery_Hours_On_Conflict = {
  constraint: Delivery_Hours_Constraint;
  update_columns?: Array<Delivery_Hours_Update_Column>;
  where?: Delivery_Hours_Bool_Exp | null | undefined;
};

/** select columns of table "delivery_hours" */
export type Delivery_Hours_Select_Column =
  /** column name */
  | 'closing_hour'
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'opening_hour'
  /** column name */
  | 'week_day';

/** update columns of table "delivery_hours" */
export type Delivery_Hours_Update_Column =
  /** column name */
  | 'closing_hour'
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'opening_hour'
  /** column name */
  | 'week_day';

export type Delivery_Zone_Administrative_Area_Aggregate_Bool_Exp = {
  count?: Delivery_Zone_Administrative_Area_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Delivery_Zone_Administrative_Area_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Delivery_Zone_Administrative_Area_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Delivery_Zone_Administrative_Area_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_Arr_Rel_Insert_Input = {
  data: Array<Delivery_Zone_Administrative_Area_Insert_Input>;
  /** upsert condition */
  on_conflict?: Delivery_Zone_Administrative_Area_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "delivery_zone_administrative_area". All fields are combined with a logical 'AND'. */
export type Delivery_Zone_Administrative_Area_Bool_Exp = {
  _and?: Array<Delivery_Zone_Administrative_Area_Bool_Exp> | null | undefined;
  _not?: Delivery_Zone_Administrative_Area_Bool_Exp | null | undefined;
  _or?: Array<Delivery_Zone_Administrative_Area_Bool_Exp> | null | undefined;
  area?: String_Comparison_Exp | null | undefined;
  country_code?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  delivery_zone?: Delivery_Zone_Bool_Exp | null | undefined;
  delivery_zone_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_Constraint =
  /** unique or primary key constraint on columns "delivery_zone_id", "country_code", "area" */
  | 'delivery_zone_administrative_area_pkey';

/** input type for inserting data into table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_Insert_Input = {
  area?: string | null | undefined;
  country_code?: string | null | undefined;
  created_at?: string | null | undefined;
  delivery_zone?: Delivery_Zone_Obj_Rel_Insert_Input | null | undefined;
  delivery_zone_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_On_Conflict = {
  constraint: Delivery_Zone_Administrative_Area_Constraint;
  update_columns?: Array<Delivery_Zone_Administrative_Area_Update_Column>;
  where?: Delivery_Zone_Administrative_Area_Bool_Exp | null | undefined;
};

/** select columns of table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_Select_Column =
  /** column name */
  | 'area'
  /** column name */
  | 'country_code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'delivery_zone_id'
  /** column name */
  | 'updated_at';

/** update columns of table "delivery_zone_administrative_area" */
export type Delivery_Zone_Administrative_Area_Update_Column =
  /** column name */
  | 'area'
  /** column name */
  | 'country_code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'delivery_zone_id'
  /** column name */
  | 'updated_at';

export type Delivery_Zone_Aggregate_Bool_Exp = {
  bool_and?: Delivery_Zone_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Delivery_Zone_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Delivery_Zone_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Delivery_Zone_Aggregate_Bool_Exp_Bool_And = {
  arguments: Delivery_Zone_Select_Column_Delivery_Zone_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Delivery_Zone_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Zone_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Delivery_Zone_Select_Column_Delivery_Zone_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Delivery_Zone_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Zone_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Delivery_Zone_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Delivery_Zone_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "delivery_zone" */
export type Delivery_Zone_Arr_Rel_Insert_Input = {
  data: Array<Delivery_Zone_Insert_Input>;
  /** upsert condition */
  on_conflict?: Delivery_Zone_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "delivery_zone". All fields are combined with a logical 'AND'. */
export type Delivery_Zone_Bool_Exp = {
  _and?: Array<Delivery_Zone_Bool_Exp> | null | undefined;
  _not?: Delivery_Zone_Bool_Exp | null | undefined;
  _or?: Array<Delivery_Zone_Bool_Exp> | null | undefined;
  administrative_areas?: Delivery_Zone_Administrative_Area_Bool_Exp | null | undefined;
  administrative_areas_aggregate?: Delivery_Zone_Administrative_Area_Aggregate_Bool_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  delivery_time?: Int_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  index?: Int_Comparison_Exp | null | undefined;
  minimum_order_value?: Numeric_Comparison_Exp | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum_Comparison_Exp | null | undefined;
  negotiable_minimum_order_value?: Boolean_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "delivery_zone" */
export type Delivery_Zone_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'delivery_zone_pkey';

/** input type for inserting data into table "delivery_zone" */
export type Delivery_Zone_Insert_Input = {
  administrative_areas?: Delivery_Zone_Administrative_Area_Arr_Rel_Insert_Input | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  delivery_time?: number | null | undefined;
  id?: string | null | undefined;
  index?: number | null | undefined;
  minimum_order_value?: number | null | undefined;
  minimum_order_value_type?: Minimum_Order_Value_Type_Enum | null | undefined;
  negotiable_minimum_order_value?: boolean | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "delivery_zone" */
export type Delivery_Zone_Obj_Rel_Insert_Input = {
  data: Delivery_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: Delivery_Zone_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "delivery_zone" */
export type Delivery_Zone_On_Conflict = {
  constraint: Delivery_Zone_Constraint;
  update_columns?: Array<Delivery_Zone_Update_Column>;
  where?: Delivery_Zone_Bool_Exp | null | undefined;
};

/** select columns of table "delivery_zone" */
export type Delivery_Zone_Select_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'delivery_time'
  /** column name */
  | 'id'
  /** column name */
  | 'index'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'negotiable_minimum_order_value'
  /** column name */
  | 'updated_at';

/** select "delivery_zone_aggregate_bool_exp_bool_and_arguments_columns" columns of table "delivery_zone" */
export type Delivery_Zone_Select_Column_Delivery_Zone_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'negotiable_minimum_order_value';

/** select "delivery_zone_aggregate_bool_exp_bool_or_arguments_columns" columns of table "delivery_zone" */
export type Delivery_Zone_Select_Column_Delivery_Zone_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'negotiable_minimum_order_value';

/** update columns of table "delivery_zone" */
export type Delivery_Zone_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'delivery_time'
  /** column name */
  | 'id'
  /** column name */
  | 'index'
  /** column name */
  | 'minimum_order_value'
  /** column name */
  | 'minimum_order_value_type'
  /** column name */
  | 'negotiable_minimum_order_value'
  /** column name */
  | 'updated_at';

export type Document_Aggregate_Bool_Exp = {
  bool_and?: Document_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Document_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Document_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Document_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Document_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Document_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Document_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Document_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "document" */
export type Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: Document_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: Array<Document_Bool_Exp> | null | undefined;
  _not?: Document_Bool_Exp | null | undefined;
  _or?: Array<Document_Bool_Exp> | null | undefined;
  comment_id?: Uuid_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  domain?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  invoice?: Invoice_Bool_Exp | null | undefined;
  invoice_id?: Uuid_Comparison_Exp | null | undefined;
  modified_date?: Timestamptz_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  order?: Order_History_Bool_Exp | null | undefined;
  order_id?: Uuid_Comparison_Exp | null | undefined;
  path?: String_Comparison_Exp | null | undefined;
  received_emails?: Received_Email_Bool_Exp | null | undefined;
  received_emails_aggregate?: Received_Email_Aggregate_Bool_Exp | null | undefined;
  received_from_email?: Boolean_Comparison_Exp | null | undefined;
  type?: Document_Type_Enum_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "document" */
export type Document_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'document_pkey';

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  comment_id?: string | null | undefined;
  created_date?: string | null | undefined;
  domain?: string | null | undefined;
  id?: string | null | undefined;
  invoice?: Invoice_Obj_Rel_Insert_Input | null | undefined;
  invoice_id?: string | null | undefined;
  modified_date?: string | null | undefined;
  name?: string | null | undefined;
  order?: Order_History_Obj_Rel_Insert_Input | null | undefined;
  order_id?: string | null | undefined;
  path?: string | null | undefined;
  received_emails?: Received_Email_Arr_Rel_Insert_Input | null | undefined;
  received_from_email?: boolean | null | undefined;
  type?: Document_Type_Enum | null | undefined;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: Document_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: Document_Bool_Exp | null | undefined;
};

/** select columns of table "document" */
export type Document_Select_Column =
  /** column name */
  | 'comment_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'domain'
  /** column name */
  | 'id'
  /** column name */
  | 'invoice_id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'name'
  /** column name */
  | 'order_id'
  /** column name */
  | 'path'
  /** column name */
  | 'received_from_email'
  /** column name */
  | 'type';

/** select "document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "document" */
export type Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'received_from_email';

/** select "document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "document" */
export type Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'received_from_email';

export type Document_Type_Enum =
  /** file related to a comment */
  | 'COMMENT_FILE'
  | 'DELIVERY_NOTE'
  /** type for invoice document */
  | 'INVOICE'
  | 'ORDER_SUMMARY'
  | 'PURCHASE_ORDER';

/** Boolean expression to compare columns of type "document_type_enum". All fields are combined with logical 'AND'. */
export type Document_Type_Enum_Comparison_Exp = {
  _eq?: Document_Type_Enum | null | undefined;
  _in?: Array<Document_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Document_Type_Enum | null | undefined;
  _nin?: Array<Document_Type_Enum> | null | undefined;
};

/** update columns of table "document" */
export type Document_Update_Column =
  /** column name */
  | 'comment_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'domain'
  /** column name */
  | 'id'
  /** column name */
  | 'invoice_id'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'name'
  /** column name */
  | 'order_id'
  /** column name */
  | 'path'
  /** column name */
  | 'received_from_email'
  /** column name */
  | 'type';

export type Duration_Type_Enum =
  /** days duration type */
  | 'DAYS'
  /** months duration type */
  | 'MONTHS'
  /** years duration type */
  | 'YEARS';

/** Boolean expression to compare columns of type "duration_type_enum". All fields are combined with logical 'AND'. */
export type Duration_Type_Enum_Comparison_Exp = {
  _eq?: Duration_Type_Enum | null | undefined;
  _in?: Array<Duration_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Duration_Type_Enum | null | undefined;
  _nin?: Array<Duration_Type_Enum> | null | undefined;
};

export type Global_Product_Family_Enum =
  | 'ALL'
  | 'NONE';

/** Boolean expression to compare columns of type "global_product_family_enum". All fields are combined with logical 'AND'. */
export type Global_Product_Family_Enum_Comparison_Exp = {
  _eq?: Global_Product_Family_Enum | null | undefined;
  _in?: Array<Global_Product_Family_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Global_Product_Family_Enum | null | undefined;
  _nin?: Array<Global_Product_Family_Enum> | null | undefined;
};

export type Gtin_Type_Enum =
  | 'GTIN_8'
  | 'GTIN_12'
  | 'GTIN_13'
  | 'GTIN_14';

/** Boolean expression to compare columns of type "gtin_type_enum". All fields are combined with logical 'AND'. */
export type Gtin_Type_Enum_Comparison_Exp = {
  _eq?: Gtin_Type_Enum | null | undefined;
  _in?: Array<Gtin_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Gtin_Type_Enum | null | undefined;
  _nin?: Array<Gtin_Type_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: Array<Invoice_Bool_Exp> | null | undefined;
  _not?: Invoice_Bool_Exp | null | undefined;
  _or?: Array<Invoice_Bool_Exp> | null | undefined;
  auto_generated?: Boolean_Comparison_Exp | null | undefined;
  comment?: String_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  contract?: Contract_Bool_Exp | null | undefined;
  contract_reference_id?: Uuid_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  documents?: Document_Bool_Exp | null | undefined;
  documents_aggregate?: Document_Aggregate_Bool_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  issue_date?: Timestamptz_Comparison_Exp | null | undefined;
  modified_date?: Timestamptz_Comparison_Exp | null | undefined;
  order?: Order_History_Bool_Exp | null | undefined;
  order_id?: Uuid_Comparison_Exp | null | undefined;
  order_number?: String_Comparison_Exp | null | undefined;
  price_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  price_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  reference?: String_Comparison_Exp | null | undefined;
  revised_price_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  revised_price_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  revised_reference?: String_Comparison_Exp | null | undefined;
  status?: Invoice_Status_Enum_Comparison_Exp | null | undefined;
  type?: Invoice_Type_Enum_Comparison_Exp | null | undefined;
  will_be_matched?: Boolean_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "invoice" */
export type Invoice_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'invoice_pkey'
  /** unique or primary key constraint on columns "reference", "company_id" */
  | 'uq_auto_generated_invoice_reference_company_id';

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  auto_generated?: boolean | null | undefined;
  comment?: string | null | undefined;
  company_id?: string | null | undefined;
  contract?: Contract_Obj_Rel_Insert_Input | null | undefined;
  contract_reference_id?: string | null | undefined;
  created_date?: string | null | undefined;
  documents?: Document_Arr_Rel_Insert_Input | null | undefined;
  id?: string | null | undefined;
  issue_date?: string | null | undefined;
  modified_date?: string | null | undefined;
  order?: Order_History_Obj_Rel_Insert_Input | null | undefined;
  order_id?: string | null | undefined;
  order_number?: string | null | undefined;
  price_excl_tax?: number | null | undefined;
  price_incl_tax?: number | null | undefined;
  reference?: string | null | undefined;
  revised_price_excl_tax?: number | null | undefined;
  revised_price_incl_tax?: number | null | undefined;
  revised_reference?: string | null | undefined;
  status?: Invoice_Status_Enum | null | undefined;
  type?: Invoice_Type_Enum | null | undefined;
  will_be_matched?: boolean | null | undefined;
};

/** input type for inserting object relation for remote table "invoice" */
export type Invoice_Obj_Rel_Insert_Input = {
  data: Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: Invoice_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: Invoice_Bool_Exp | null | undefined;
};

export type Invoice_Status_Enum =
  | 'AUTO_MATCHED'
  | 'DISCARDED'
  | 'MANUALLY_MATCHED'
  | 'SENT_TO_BUYER'
  | 'UNMATCHED';

/** Boolean expression to compare columns of type "invoice_status_enum". All fields are combined with logical 'AND'. */
export type Invoice_Status_Enum_Comparison_Exp = {
  _eq?: Invoice_Status_Enum | null | undefined;
  _in?: Array<Invoice_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Invoice_Status_Enum | null | undefined;
  _nin?: Array<Invoice_Status_Enum> | null | undefined;
};

export type Invoice_Type_Enum =
  /** commission invoice */
  | 'COMMISSION'
  /** order invoice */
  | 'ORDER';

/** Boolean expression to compare columns of type "invoice_type_enum". All fields are combined with logical 'AND'. */
export type Invoice_Type_Enum_Comparison_Exp = {
  _eq?: Invoice_Type_Enum | null | undefined;
  _in?: Array<Invoice_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Invoice_Type_Enum | null | undefined;
  _nin?: Array<Invoice_Type_Enum> | null | undefined;
};

/** update columns of table "invoice" */
export type Invoice_Update_Column =
  /** column name */
  | 'auto_generated'
  /** column name */
  | 'comment'
  /** column name */
  | 'company_id'
  /** column name */
  | 'contract_reference_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'id'
  /** column name */
  | 'issue_date'
  /** column name */
  | 'modified_date'
  /** column name */
  | 'order_id'
  /** column name */
  | 'order_number'
  /** column name */
  | 'price_excl_tax'
  /** column name */
  | 'price_incl_tax'
  /** column name */
  | 'reference'
  /** column name */
  | 'revised_price_excl_tax'
  /** column name */
  | 'revised_price_incl_tax'
  /** column name */
  | 'revised_reference'
  /** column name */
  | 'status'
  /** column name */
  | 'type'
  /** column name */
  | 'will_be_matched';

export type Jsonb_Cast_Exp = {
  String?: String_Comparison_Exp | null | undefined;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: Jsonb_Cast_Exp | null | undefined;
  /** is the column contained in the given json value */
  _contained_in?: { [key: string]: any } | null | null | undefined;
  /** does the column contain the given json value at the top level */
  _contains?: { [key: string]: any } | null | null | undefined;
  _eq?: { [key: string]: any } | null | null | undefined;
  _gt?: { [key: string]: any } | null | null | undefined;
  _gte?: { [key: string]: any } | null | null | undefined;
  /** does the string exist as a top-level key in the column */
  _has_key?: string | null | undefined;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Array<string> | null | undefined;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Array<string> | null | undefined;
  _in?: Array<{ [key: string]: any } | null> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: { [key: string]: any } | null | null | undefined;
  _lte?: { [key: string]: any } | null | null | undefined;
  _neq?: { [key: string]: any } | null | null | undefined;
  _nin?: Array<{ [key: string]: any } | null> | null | undefined;
};

export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

/** Boolean expression to compare columns of type "marketing_support_enum". All fields are combined with logical 'AND'. */
export type Marketing_Support_Enum_Comparison_Exp = {
  _eq?: Marketing_Support_Enum | null | undefined;
  _in?: Array<Marketing_Support_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Marketing_Support_Enum | null | undefined;
  _nin?: Array<Marketing_Support_Enum> | null | undefined;
};

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

/** Boolean expression to compare columns of type "measurement_unit_enum". All fields are combined with logical 'AND'. */
export type Measurement_Unit_Enum_Comparison_Exp = {
  _eq?: Measurement_Unit_Enum | null | undefined;
  _in?: Array<Measurement_Unit_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Measurement_Unit_Enum | null | undefined;
  _nin?: Array<Measurement_Unit_Enum> | null | undefined;
};

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

/** Boolean expression to compare columns of type "minimum_order_value_type_enum". All fields are combined with logical 'AND'. */
export type Minimum_Order_Value_Type_Enum_Comparison_Exp = {
  _eq?: Minimum_Order_Value_Type_Enum | null | undefined;
  _in?: Array<Minimum_Order_Value_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Minimum_Order_Value_Type_Enum | null | undefined;
  _nin?: Array<Minimum_Order_Value_Type_Enum> | null | undefined;
};

export type Notification_Code_Enum =
  /** A Money-in on Lemonway's wallet couldn't be reconciliated with an order. */
  | 'A100'
  /** We couldn't execute the whole payment process for an order. */
  | 'A101'
  /** SDD request to Lemonway failed */
  | 'A102'
  /** comment created */
  | 'C100'
  /** there are  unread messages in channel */
  | 'CH100'
  /** The discount has been updated on a contract */
  | 'CT100'
  /** The minimum order value has been updated on the contract */
  | 'CT101'
  /** document created */
  | 'D100'
  /** Send unmatched invoice to Buyer */
  | 'D102'
  /** Supplier sent an invoice in a format not supported */
  | 'D103'
  /** document updated */
  | 'D200'
  /** new order created */
  | 'O100'
  /** new order received */
  | 'O101'
  /** new order suggestion received */
  | 'O102'
  /** Reminder of all order suggestions of more than 48 hours with no response */
  | 'O103'
  /** Creation of a new order suggestion by STAFF_ADMIN on behalf of Supplier */
  | 'O104'
  /** Weekly algorithm recommendations for restocking orders */
  | 'O150'
  /** order to be validated by the supplier */
  | 'O200'
  /** Reminder #1 to the supplier to validate the order */
  | 'O210'
  /** Reminder #2 to the supplier to validate the order */
  | 'O211'
  /** Reminder #3 to the supplier to validate the order */
  | 'O212'
  /** Order quantities have been changed by the buyer in the to_be_validated_by_supplier status. */
  | 'O220'
  /** order to be validated by the buyer */
  | 'O300'
  /** Order quantities have been changed by the supplier in the to_be_validated_by_buyer status. */
  | 'O320'
  /** order has been validated */
  | 'O350'
  /** Order has automatically been validated after 1 business day */
  | 'O351'
  /** Order passed by buyer with a suggested delivery time has been validated by supplier with a modification in delivery date or time */
  | 'O352'
  /** Suggested Order from a trusted Supplier has automatically been validated */
  | 'O353'
  /** order to be delivered by supplier */
  | 'O400'
  /** Order must be delivered tomorrow */
  | 'O401'
  /** Order delivery was rejected by BUYER */
  | 'O402'
  /** Order quantities have been changed by the supplier in the to_be_prepared_by_supplier status. */
  | 'O420'
  /** order delivery date update */
  | 'O500'
  /** order auto delivery confirmation */
  | 'O501'
  /** order to be received by buyer */
  | 'O600'
  /** order auto reception confirmation */
  | 'O601'
  /** Order has been in the `to_be_received_by_buyer` state for two days, and will be auto received in 1 day */
  | 'O602'
  /** Order quantities have been changed by the supplier in the `to_be_received_by_buyer` step */
  | 'O603'
  /** Order was received by BUYER and has to be paid by BUYER. */
  | 'O604'
  /** Order was received by BUYER with changed quantities and has to be paid by BUYER */
  | 'O605'
  /** Order was received by BUYER and is being paid by BUYER */
  | 'O606'
  /** Order was received by BUYER with changed quantities and is being paid by BUYER */
  | 'O607'
  /** Order quantities have been changed by the supplier in the to_be_delivered_by_supplier status. */
  | 'O620'
  /** Order quantities have been changed by the supplier in the to_be_received_by_buyer status. Order still has to be received by buyer. */
  | 'O621'
  /** order to be billed by supplier */
  | 'O700'
  /** order to be paid by buyer */
  | 'O701'
  /** order being paid by buyer for sdd payment */
  | 'O702'
  /** Order must be paid by buyer (order amounts have been modified) */
  | 'O703'
  /** Direct Debit has been planned by Buyer, order will be paid. */
  | 'O704'
  /** order closed */
  | 'O800'
  /** Order has been paid by Kheops and is now closed. */
  | 'O801'
  /** Order has been indicated as paid by Supplier and is now closed */
  | 'O802'
  /** Supplier has indicated that payment was not received and reopened order. */
  | 'O803'
  /** order has been cancelled by buyer */
  | 'O900'
  /** order has been cancelled by supplier */
  | 'O901'
  /** Order has been archived by Kheops */
  | 'O902'
  /** Order suggestion has been archived by Kheops */
  | 'O903'
  /** When a Supplier updates one of his product price, inform Buyers collaborating with Supplier */
  | 'P100'
  /** Buyers that never used wishlist. */
  | 'R120'
  /** Inform SSR about Buyer(s) interest */
  | 'R121'
  /** creation of a new user account */
  | 'U100'
  /** Weekly new suppliers for buyers */
  | 'W100'
  /** Weekly new buyers for suppliers */
  | 'W101';

/** Boolean expression to compare columns of type "notification_code_enum". All fields are combined with logical 'AND'. */
export type Notification_Code_Enum_Comparison_Exp = {
  _eq?: Notification_Code_Enum | null | undefined;
  _in?: Array<Notification_Code_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Notification_Code_Enum | null | undefined;
  _nin?: Array<Notification_Code_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "notification_method". All fields are combined with a logical 'AND'. */
export type Notification_Method_Bool_Exp = {
  _and?: Array<Notification_Method_Bool_Exp> | null | undefined;
  _not?: Notification_Method_Bool_Exp | null | undefined;
  _or?: Array<Notification_Method_Bool_Exp> | null | undefined;
  code?: Notification_Code_Enum_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  email?: Boolean_Comparison_Exp | null | undefined;
  sms?: Boolean_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  user_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "notification_method" */
export type Notification_Method_Constraint =
  /** unique or primary key constraint on columns "user_id", "code" */
  | 'notification_method_pkey';

/** input type for inserting data into table "notification_method" */
export type Notification_Method_Insert_Input = {
  code?: Notification_Code_Enum | null | undefined;
  created_at?: string | null | undefined;
  email?: boolean | null | undefined;
  sms?: boolean | null | undefined;
  updated_at?: string | null | undefined;
  user_id?: string | null | undefined;
};

/** input type for inserting object relation for remote table "notification_method" */
export type Notification_Method_Obj_Rel_Insert_Input = {
  data: Notification_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: Notification_Method_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "notification_method" */
export type Notification_Method_On_Conflict = {
  constraint: Notification_Method_Constraint;
  update_columns?: Array<Notification_Method_Update_Column>;
  where?: Notification_Method_Bool_Exp | null | undefined;
};

/** update columns of table "notification_method" */
export type Notification_Method_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'sms'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

export type Notification_Scope_Enum =
  | 'ADMIN'
  | 'CHAT'
  | 'CONTRACT'
  | 'ORDER'
  | 'ORDER_DOCUMENT'
  | 'PRODUCT'
  | 'REPORTING'
  | 'USER'
  | 'WEEKLY';

/** Boolean expression to compare columns of type "notification_scope_enum". All fields are combined with logical 'AND'. */
export type Notification_Scope_Enum_Comparison_Exp = {
  _eq?: Notification_Scope_Enum | null | undefined;
  _in?: Array<Notification_Scope_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Notification_Scope_Enum | null | undefined;
  _nin?: Array<Notification_Scope_Enum> | null | undefined;
};

export type Notification_Subscription_Aggregate_Bool_Exp = {
  bool_and?: Notification_Subscription_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Notification_Subscription_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Notification_Subscription_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Notification_Subscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Notification_Subscription_Select_Column_Notification_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Notification_Subscription_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Subscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Notification_Subscription_Select_Column_Notification_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Notification_Subscription_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Notification_Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Notification_Subscription_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Notification_Subscription_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "notification_subscription" */
export type Notification_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Notification_Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: Notification_Subscription_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "notification_subscription". All fields are combined with a logical 'AND'. */
export type Notification_Subscription_Bool_Exp = {
  _and?: Array<Notification_Subscription_Bool_Exp> | null | undefined;
  _not?: Notification_Subscription_Bool_Exp | null | undefined;
  _or?: Array<Notification_Subscription_Bool_Exp> | null | undefined;
  code?: Notification_Code_Enum_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  notification_method?: Notification_Method_Bool_Exp | null | undefined;
  object_id?: String_Comparison_Exp | null | undefined;
  scope?: Notification_Scope_Enum_Comparison_Exp | null | undefined;
  subscribed?: Boolean_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
  user_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "notification_subscription" */
export type Notification_Subscription_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'notification_subscription_pkey';

/** input type for inserting data into table "notification_subscription" */
export type Notification_Subscription_Insert_Input = {
  code?: Notification_Code_Enum | null | undefined;
  company_id?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  notification_method?: Notification_Method_Obj_Rel_Insert_Input | null | undefined;
  object_id?: string | null | undefined;
  scope?: Notification_Scope_Enum | null | undefined;
  subscribed?: boolean | null | undefined;
  updated_at?: string | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
  user_id?: string | null | undefined;
};

/** on_conflict condition type for table "notification_subscription" */
export type Notification_Subscription_On_Conflict = {
  constraint: Notification_Subscription_Constraint;
  update_columns?: Array<Notification_Subscription_Update_Column>;
  where?: Notification_Subscription_Bool_Exp | null | undefined;
};

/** select columns of table "notification_subscription" */
export type Notification_Subscription_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'object_id'
  /** column name */
  | 'scope'
  /** column name */
  | 'subscribed'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** select "notification_subscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notification_subscription" */
export type Notification_Subscription_Select_Column_Notification_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'subscribed';

/** select "notification_subscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notification_subscription" */
export type Notification_Subscription_Select_Column_Notification_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'subscribed';

/** update columns of table "notification_subscription" */
export type Notification_Subscription_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'object_id'
  /** column name */
  | 'scope'
  /** column name */
  | 'subscribed'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'user_id';

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: number | null | undefined;
  _gt?: number | null | undefined;
  _gte?: number | null | undefined;
  _in?: Array<number> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: number | null | undefined;
  _lte?: number | null | undefined;
  _neq?: number | null | undefined;
  _nin?: Array<number> | null | undefined;
};

export type Order_Aggregate_Bool_Exp = {
  bool_and?: Order_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Order_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Order_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Order_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Order_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Order_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Order_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "order" */
export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: Order_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: Array<Order_Bool_Exp> | null | undefined;
  _not?: Order_Bool_Exp | null | undefined;
  _or?: Array<Order_Bool_Exp> | null | undefined;
  basket_id?: Uuid_Comparison_Exp | null | undefined;
  cancelled_by?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  comments?: Comment_Bool_Exp | null | undefined;
  comments_aggregate?: Comment_Aggregate_Bool_Exp | null | undefined;
  contract?: Contract_History_Bool_Exp | null | undefined;
  contractId?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  creator_id?: Uuid_Comparison_Exp | null | undefined;
  delivery_date?: Timestamptz_Comparison_Exp | null | undefined;
  documents?: Document_Bool_Exp | null | undefined;
  documents_aggregate?: Document_Aggregate_Bool_Exp | null | undefined;
  entered_status_at?: Timestamptz_Comparison_Exp | null | undefined;
  friendly_id?: String_Comparison_Exp | null | undefined;
  has_invoice_generation?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  is_auto_validated?: Boolean_Comparison_Exp | null | undefined;
  is_relevant_for_analytics?: Boolean_Comparison_Exp | null | undefined;
  items?: Order_Item_Bool_Exp | null | undefined;
  items_aggregate?: Order_Item_Aggregate_Bool_Exp | null | undefined;
  payment_method?: Payment_Method_Enum_Comparison_Exp | null | undefined;
  payment_process_status?: Payment_Process_Status_Enum_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  sdd_payment_date?: Timestamptz_Comparison_Exp | null | undefined;
  sdd_payment_transaction_id?: Numeric_Comparison_Exp | null | undefined;
  status?: Order_Status_Enum_Comparison_Exp | null | undefined;
  suggestor?: User_Bool_Exp | null | undefined;
  suggestor_id?: Uuid_Comparison_Exp | null | undefined;
  supplier_commission_value_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  supplier_commission_value_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_to_pay_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_to_pay_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_tax?: Numeric_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: Uuid_Comparison_Exp | null | undefined;
  updater?: User_Bool_Exp | null | undefined;
  updater_business_profile?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
};

/** unique or primary key constraints on table "order" */
export type Order_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_1031171c13130102495201e3e20'
  /** unique or primary key constraint on columns "contractId", "basket_id" */
  | 'order_basket_id_contractId_key'
  /** unique or primary key constraint on columns "friendly_id" */
  | 'order_friendly_id_key'
  /** unique or primary key constraint on columns "reference_id" */
  | 'order_reference_id_key';

export type Order_History_Aggregate_Bool_Exp = {
  bool_and?: Order_History_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Order_History_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Order_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Order_History_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_History_Select_Column_Order_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Order_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Order_History_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_History_Select_Column_Order_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Order_History_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Order_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Order_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Order_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "order_history" */
export type Order_History_Arr_Rel_Insert_Input = {
  data: Array<Order_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Order_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "order_history". All fields are combined with a logical 'AND'. */
export type Order_History_Bool_Exp = {
  _and?: Array<Order_History_Bool_Exp> | null | undefined;
  _not?: Order_History_Bool_Exp | null | undefined;
  _or?: Array<Order_History_Bool_Exp> | null | undefined;
  basket_id?: Uuid_Comparison_Exp | null | undefined;
  cancelled_by?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  contract?: Contract_History_Bool_Exp | null | undefined;
  contractId?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  creator_id?: Uuid_Comparison_Exp | null | undefined;
  delivery_date?: Timestamptz_Comparison_Exp | null | undefined;
  documents?: Document_Bool_Exp | null | undefined;
  documents_aggregate?: Document_Aggregate_Bool_Exp | null | undefined;
  entered_status_at?: Timestamptz_Comparison_Exp | null | undefined;
  friendly_id?: String_Comparison_Exp | null | undefined;
  has_invoice_generation?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  is_auto_validated?: Boolean_Comparison_Exp | null | undefined;
  is_relevant_for_analytics?: Boolean_Comparison_Exp | null | undefined;
  items?: Order_Item_Bool_Exp | null | undefined;
  items_aggregate?: Order_Item_Aggregate_Bool_Exp | null | undefined;
  payment_method?: Payment_Method_Enum_Comparison_Exp | null | undefined;
  payment_process_status?: Payment_Process_Status_Enum_Comparison_Exp | null | undefined;
  reference_id?: Uuid_Comparison_Exp | null | undefined;
  sdd_payment_date?: Timestamptz_Comparison_Exp | null | undefined;
  sdd_payment_transaction_id?: Numeric_Comparison_Exp | null | undefined;
  status?: Order_Status_Enum_Comparison_Exp | null | undefined;
  suggestor_id?: Uuid_Comparison_Exp | null | undefined;
  supplier_commission_value_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_excl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_price_incl_tax?: Numeric_Comparison_Exp | null | undefined;
  total_tax?: Numeric_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  updated_by?: Uuid_Comparison_Exp | null | undefined;
  updater?: User_Bool_Exp | null | undefined;
  updater_business_profile?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "order_history" */
export type Order_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'order_history_pkey'
  /** unique or primary key constraint on columns "id" */
  | 'order_id_uq';

/** input type for inserting data into table "order_history" */
export type Order_History_Insert_Input = {
  basket_id?: string | null | undefined;
  cancelled_by?: Business_Profile_Enum | null | undefined;
  contract?: Contract_History_Obj_Rel_Insert_Input | null | undefined;
  contractId?: string | null | undefined;
  created_at?: string | null | undefined;
  creator_id?: string | null | undefined;
  delivery_date?: string | null | undefined;
  documents?: Document_Arr_Rel_Insert_Input | null | undefined;
  friendly_id?: string | null | undefined;
  has_invoice_generation?: boolean | null | undefined;
  id?: string | null | undefined;
  is_auto_validated?: boolean | null | undefined;
  is_relevant_for_analytics?: boolean | null | undefined;
  items?: Order_Item_Arr_Rel_Insert_Input | null | undefined;
  payment_method?: Payment_Method_Enum | null | undefined;
  payment_process_status?: Payment_Process_Status_Enum | null | undefined;
  reference_id?: string | null | undefined;
  sdd_payment_date?: string | null | undefined;
  sdd_payment_transaction_id?: number | null | undefined;
  status?: Order_Status_Enum | null | undefined;
  suggestor_id?: string | null | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
  updater?: User_Obj_Rel_Insert_Input | null | undefined;
  updater_business_profile?: string | null | undefined;
};

/** input type for inserting object relation for remote table "order_history" */
export type Order_History_Obj_Rel_Insert_Input = {
  data: Order_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Order_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "order_history" */
export type Order_History_On_Conflict = {
  constraint: Order_History_Constraint;
  update_columns?: Array<Order_History_Update_Column>;
  where?: Order_History_Bool_Exp | null | undefined;
};

/** select columns of table "order_history" */
export type Order_History_Select_Column =
  /** column name */
  | 'basket_id'
  /** column name */
  | 'cancelled_by'
  /** column name */
  | 'contractId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'creator_id'
  /** column name */
  | 'delivery_date'
  /** column name */
  | 'friendly_id'
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'id'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'payment_process_status'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'sdd_payment_date'
  /** column name */
  | 'sdd_payment_transaction_id'
  /** column name */
  | 'status'
  /** column name */
  | 'suggestor_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'updater_business_profile';

/** select "order_history_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_history" */
export type Order_History_Select_Column_Order_History_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics';

/** select "order_history_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_history" */
export type Order_History_Select_Column_Order_History_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics';

/** update columns of table "order_history" */
export type Order_History_Update_Column =
  /** column name */
  | 'basket_id'
  /** column name */
  | 'cancelled_by'
  /** column name */
  | 'contractId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'creator_id'
  /** column name */
  | 'delivery_date'
  /** column name */
  | 'friendly_id'
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'id'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'payment_process_status'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'sdd_payment_date'
  /** column name */
  | 'sdd_payment_transaction_id'
  /** column name */
  | 'status'
  /** column name */
  | 'suggestor_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'updater_business_profile';

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  basket_id?: string | null | undefined;
  cancelled_by?: Business_Profile_Enum | null | undefined;
  comments?: Comment_Arr_Rel_Insert_Input | null | undefined;
  contract?: Contract_History_Obj_Rel_Insert_Input | null | undefined;
  contractId?: string | null | undefined;
  created_at?: string | null | undefined;
  creator_id?: string | null | undefined;
  delivery_date?: string | null | undefined;
  documents?: Document_Arr_Rel_Insert_Input | null | undefined;
  friendly_id?: string | null | undefined;
  has_invoice_generation?: boolean | null | undefined;
  id?: string | null | undefined;
  is_auto_validated?: boolean | null | undefined;
  is_relevant_for_analytics?: boolean | null | undefined;
  items?: Order_Item_Arr_Rel_Insert_Input | null | undefined;
  payment_method?: Payment_Method_Enum | null | undefined;
  payment_process_status?: Payment_Process_Status_Enum | null | undefined;
  reference_id?: string | null | undefined;
  sdd_payment_date?: string | null | undefined;
  sdd_payment_transaction_id?: number | null | undefined;
  status?: Order_Status_Enum | null | undefined;
  suggestor?: User_Obj_Rel_Insert_Input | null | undefined;
  suggestor_id?: string | null | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
  updater?: User_Obj_Rel_Insert_Input | null | undefined;
  updater_business_profile?: Business_Profile_Enum | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
};

export type Order_Item_Aggregate_Bool_Exp = {
  count?: Order_Item_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Order_Item_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Order_Item_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Order_Item_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "order_item" */
export type Order_Item_Arr_Rel_Insert_Input = {
  data: Array<Order_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: Order_Item_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "order_item". All fields are combined with a logical 'AND'. */
export type Order_Item_Bool_Exp = {
  _and?: Array<Order_Item_Bool_Exp> | null | undefined;
  _not?: Order_Item_Bool_Exp | null | undefined;
  _or?: Array<Order_Item_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  order?: Order_History_Bool_Exp | null | undefined;
  orderId?: Uuid_Comparison_Exp | null | undefined;
  packaging?: Packaging_History_Bool_Exp | null | undefined;
  packagingId?: Uuid_Comparison_Exp | null | undefined;
  price?: Numeric_Comparison_Exp | null | undefined;
  quantity?: Int_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  weight?: Numeric_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "order_item" */
export type Order_Item_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_ec6b3f7bb5c277c7361c14466e3'
  /** unique or primary key constraint on columns "packagingId", "orderId", "quantity" */
  | 'UQ_8ec0fa89bfa79d63589c5fc5ccd';

/** input type for inserting data into table "order_item" */
export type Order_Item_Insert_Input = {
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  order?: Order_History_Obj_Rel_Insert_Input | null | undefined;
  orderId?: string | null | undefined;
  packaging?: Packaging_History_Obj_Rel_Insert_Input | null | undefined;
  packagingId?: string | null | undefined;
  price?: number | null | undefined;
  quantity?: number | null | undefined;
  updated_at?: string | null | undefined;
  weight?: number | null | undefined;
};

/** on_conflict condition type for table "order_item" */
export type Order_Item_On_Conflict = {
  constraint: Order_Item_Constraint;
  update_columns?: Array<Order_Item_Update_Column>;
  where?: Order_Item_Bool_Exp | null | undefined;
};

/** select columns of table "order_item" */
export type Order_Item_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'orderId'
  /** column name */
  | 'packagingId'
  /** column name */
  | 'price'
  /** column name */
  | 'quantity'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'weight';

/** update columns of table "order_item" */
export type Order_Item_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'orderId'
  /** column name */
  | 'packagingId'
  /** column name */
  | 'price'
  /** column name */
  | 'quantity'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'weight';

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: Order_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: Order_Bool_Exp | null | undefined;
};

/** select columns of table "order" */
export type Order_Select_Column =
  /** column name */
  | 'basket_id'
  /** column name */
  | 'cancelled_by'
  /** column name */
  | 'contractId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'creator_id'
  /** column name */
  | 'delivery_date'
  /** column name */
  | 'friendly_id'
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'id'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'payment_process_status'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'sdd_payment_date'
  /** column name */
  | 'sdd_payment_transaction_id'
  /** column name */
  | 'status'
  /** column name */
  | 'suggestor_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'updater_business_profile';

/** select "order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order" */
export type Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics';

/** select "order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order" */
export type Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics';

export type Order_Status_Enum =
  | 'closed_but_contested_payment'
  | 'order_archived'
  | 'order_being_paid_by_buyer'
  | 'order_cancelled'
  | 'order_closed'
  | 'order_to_be_billed_by_supplier'
  | 'order_to_be_delivered_by_supplier'
  | 'order_to_be_paid_by_buyer'
  | 'order_to_be_prepared_by_supplier'
  | 'order_to_be_received_by_buyer'
  | 'order_to_be_validated_by_buyer'
  | 'order_to_be_validated_by_supplier';

/** Boolean expression to compare columns of type "order_status_enum". All fields are combined with logical 'AND'. */
export type Order_Status_Enum_Comparison_Exp = {
  _eq?: Order_Status_Enum | null | undefined;
  _in?: Array<Order_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Order_Status_Enum | null | undefined;
  _nin?: Array<Order_Status_Enum> | null | undefined;
};

/** update columns of table "order" */
export type Order_Update_Column =
  /** column name */
  | 'basket_id'
  /** column name */
  | 'cancelled_by'
  /** column name */
  | 'contractId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'creator_id'
  /** column name */
  | 'delivery_date'
  /** column name */
  | 'friendly_id'
  /** column name */
  | 'has_invoice_generation'
  /** column name */
  | 'id'
  /** column name */
  | 'is_auto_validated'
  /** column name */
  | 'is_relevant_for_analytics'
  /** column name */
  | 'payment_method'
  /** column name */
  | 'payment_process_status'
  /** column name */
  | 'reference_id'
  /** column name */
  | 'sdd_payment_date'
  /** column name */
  | 'sdd_payment_transaction_id'
  /** column name */
  | 'status'
  /** column name */
  | 'suggestor_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'updater_business_profile';

export type Packaging_Aggregate_Bool_Exp = {
  count?: Packaging_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Packaging_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Packaging_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Packaging_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "packaging" */
export type Packaging_Arr_Rel_Insert_Input = {
  data: Array<Packaging_Insert_Input>;
  /** upsert condition */
  on_conflict?: Packaging_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "packaging". All fields are combined with a logical 'AND'. */
export type Packaging_Bool_Exp = {
  _and?: Array<Packaging_Bool_Exp> | null | undefined;
  _not?: Packaging_Bool_Exp | null | undefined;
  _or?: Array<Packaging_Bool_Exp> | null | undefined;
  base_unit?: Base_Unit_Bool_Exp | null | undefined;
  base_unit_id?: Uuid_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_baseUnitSku?: String_Comparison_Exp | null | undefined;
  deprecated_default_price_id?: Uuid_Comparison_Exp | null | undefined;
  deprecated_parentSku?: String_Comparison_Exp | null | undefined;
  deprecated_productSku?: String_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  gtin?: String_Comparison_Exp | null | undefined;
  gtin_type?: Gtin_Type_Enum_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  net_content?: Numeric_Comparison_Exp | null | undefined;
  parent_id?: Uuid_Comparison_Exp | null | undefined;
  price?: Numeric_Comparison_Exp | null | undefined;
  product?: Product_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  trade_item_unit_descriptor?: Trade_Item_Unit_Descriptor_Enum_Comparison_Exp | null | undefined;
  unit_quantity?: Int_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "packaging" */
export type Packaging_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_c555edac95babf9a092ff829eba'
  /** unique or primary key constraint on columns "gtin" */
  | 'REL_4008e423352b403348a14107e5'
  /** unique or primary key constraint on columns "sku", "company_id" */
  | 'packaging_company_id_sku_unique';

export type Packaging_History_Aggregate_Bool_Exp = {
  count?: Packaging_History_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Packaging_History_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Packaging_History_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Packaging_History_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "packaging_history" */
export type Packaging_History_Arr_Rel_Insert_Input = {
  data: Array<Packaging_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: Packaging_History_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "packaging_history". All fields are combined with a logical 'AND'. */
export type Packaging_History_Bool_Exp = {
  _and?: Array<Packaging_History_Bool_Exp> | null | undefined;
  _not?: Packaging_History_Bool_Exp | null | undefined;
  _or?: Array<Packaging_History_Bool_Exp> | null | undefined;
  base_unit?: Base_Unit_History_Bool_Exp | null | undefined;
  base_unit_id?: Uuid_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_baseUnitSku?: String_Comparison_Exp | null | undefined;
  deprecated_default_price_id?: Uuid_Comparison_Exp | null | undefined;
  deprecated_parentSku?: String_Comparison_Exp | null | undefined;
  deprecated_productSku?: String_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  gtin?: String_Comparison_Exp | null | undefined;
  gtin_type?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  net_content?: Numeric_Comparison_Exp | null | undefined;
  parent_id?: Uuid_Comparison_Exp | null | undefined;
  price?: Numeric_Comparison_Exp | null | undefined;
  product?: Product_History_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  trade_item_unit_descriptor?: Trade_Item_Unit_Descriptor_Enum_Comparison_Exp | null | undefined;
  unit_quantity?: Int_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "packaging_history" */
export type Packaging_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'packaging_history_pkey';

/** input type for inserting data into table "packaging_history" */
export type Packaging_History_Insert_Input = {
  base_unit?: Base_Unit_History_Obj_Rel_Insert_Input | null | undefined;
  base_unit_id?: string | null | undefined;
  company_id?: string | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum | null | undefined;
  created_date?: string | null | undefined;
  deprecated_baseUnitSku?: string | null | undefined;
  deprecated_default_price_id?: string | null | undefined;
  deprecated_parentSku?: string | null | undefined;
  deprecated_productSku?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  gtin?: string | null | undefined;
  gtin_type?: string | null | undefined;
  id?: string | null | undefined;
  net_content?: number | null | undefined;
  parent_id?: string | null | undefined;
  price?: number | null | undefined;
  product?: Product_History_Obj_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  sku?: number | null | undefined;
  trade_item_unit_descriptor?: Trade_Item_Unit_Descriptor_Enum | null | undefined;
  unit_quantity?: number | null | undefined;
};

/** input type for inserting object relation for remote table "packaging_history" */
export type Packaging_History_Obj_Rel_Insert_Input = {
  data: Packaging_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Packaging_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "packaging_history" */
export type Packaging_History_On_Conflict = {
  constraint: Packaging_History_Constraint;
  update_columns?: Array<Packaging_History_Update_Column>;
  where?: Packaging_History_Bool_Exp | null | undefined;
};

/** select columns of table "packaging_history" */
export type Packaging_History_Select_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_baseUnitSku'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_parentSku'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'net_content'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'price'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'trade_item_unit_descriptor'
  /** column name */
  | 'unit_quantity';

/** update columns of table "packaging_history" */
export type Packaging_History_Update_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_baseUnitSku'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_parentSku'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'net_content'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'price'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'trade_item_unit_descriptor'
  /** column name */
  | 'unit_quantity';

/** input type for inserting data into table "packaging" */
export type Packaging_Insert_Input = {
  base_unit?: Base_Unit_Obj_Rel_Insert_Input | null | undefined;
  base_unit_id?: string | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  content_measurement_unit?: Measurement_Unit_Enum | null | undefined;
  created_date?: string | null | undefined;
  deprecated_baseUnitSku?: string | null | undefined;
  deprecated_default_price_id?: string | null | undefined;
  deprecated_parentSku?: string | null | undefined;
  deprecated_productSku?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  gtin?: string | null | undefined;
  gtin_type?: Gtin_Type_Enum | null | undefined;
  id?: string | null | undefined;
  net_content?: number | null | undefined;
  parent_id?: string | null | undefined;
  price?: number | null | undefined;
  product?: Product_Obj_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  sku?: number | null | undefined;
  trade_item_unit_descriptor?: Trade_Item_Unit_Descriptor_Enum | null | undefined;
  unit_quantity?: number | null | undefined;
};

/** input type for inserting object relation for remote table "packaging" */
export type Packaging_Obj_Rel_Insert_Input = {
  data: Packaging_Insert_Input;
  /** upsert condition */
  on_conflict?: Packaging_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "packaging" */
export type Packaging_On_Conflict = {
  constraint: Packaging_Constraint;
  update_columns?: Array<Packaging_Update_Column>;
  where?: Packaging_Bool_Exp | null | undefined;
};

/** select columns of table "packaging" */
export type Packaging_Select_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_baseUnitSku'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_parentSku'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'net_content'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'price'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'trade_item_unit_descriptor'
  /** column name */
  | 'unit_quantity';

/** update columns of table "packaging" */
export type Packaging_Update_Column =
  /** column name */
  | 'base_unit_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'content_measurement_unit'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deprecated_baseUnitSku'
  /** column name */
  | 'deprecated_default_price_id'
  /** column name */
  | 'deprecated_parentSku'
  /** column name */
  | 'deprecated_productSku'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'gtin'
  /** column name */
  | 'gtin_type'
  /** column name */
  | 'id'
  /** column name */
  | 'net_content'
  /** column name */
  | 'parent_id'
  /** column name */
  | 'price'
  /** column name */
  | 'product_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'trade_item_unit_descriptor'
  /** column name */
  | 'unit_quantity';

export type Payment_Method_Enum =
  | 'BANK_TRANSFER'
  | 'NO_PAYMENT'
  | 'SDD_AUTO'
  | 'SDD_TRIGGERED';

/** Boolean expression to compare columns of type "payment_method_enum". All fields are combined with logical 'AND'. */
export type Payment_Method_Enum_Comparison_Exp = {
  _eq?: Payment_Method_Enum | null | undefined;
  _in?: Array<Payment_Method_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Payment_Method_Enum | null | undefined;
  _nin?: Array<Payment_Method_Enum> | null | undefined;
};

export type Payment_Process_Status_Enum =
  /** The process payment is finished. */
  | 'Finished'
  /** We received the money in on Lemonway and successfuly linked it to an order. */
  | 'MoneyInReceived'
  /** We have initiated the money transfer from Lemonway to the supplier's real bank account. */
  | 'MoneyOutPerformed'
  /** We have credited the supplier's account on Lemonway. */
  | 'SupplierAccountCredited'
  /** The order's payment is managed by Lemonway, we are waiting for the money in from the buyer. */
  | 'WaitingForMoneyIn';

/** Boolean expression to compare columns of type "payment_process_status_enum". All fields are combined with logical 'AND'. */
export type Payment_Process_Status_Enum_Comparison_Exp = {
  _eq?: Payment_Process_Status_Enum | null | undefined;
  _in?: Array<Payment_Process_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Payment_Process_Status_Enum | null | undefined;
  _nin?: Array<Payment_Process_Status_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "photo". All fields are combined with a logical 'AND'. */
export type Photo_Bool_Exp = {
  _and?: Array<Photo_Bool_Exp> | null | undefined;
  _not?: Photo_Bool_Exp | null | undefined;
  _or?: Array<Photo_Bool_Exp> | null | undefined;
  base_unit_id_deprecated?: Uuid_Comparison_Exp | null | undefined;
  companyId_deprecated?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  domain?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  path?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "photo" */
export type Photo_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_cda7cad80fc363fd735aefa13a9';

/** input type for inserting data into table "photo" */
export type Photo_Insert_Input = {
  base_unit_id_deprecated?: string | null | undefined;
  companyId_deprecated?: string | null | undefined;
  created_at?: string | null | undefined;
  domain?: string | null | undefined;
  id?: string | null | undefined;
  path?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "photo" */
export type Photo_Obj_Rel_Insert_Input = {
  data: Photo_Insert_Input;
  /** upsert condition */
  on_conflict?: Photo_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "photo" */
export type Photo_On_Conflict = {
  constraint: Photo_Constraint;
  update_columns?: Array<Photo_Update_Column>;
  where?: Photo_Bool_Exp | null | undefined;
};

/** update columns of table "photo" */
export type Photo_Update_Column =
  /** column name */
  | 'base_unit_id_deprecated'
  /** column name */
  | 'companyId_deprecated'
  /** column name */
  | 'created_at'
  /** column name */
  | 'domain'
  /** column name */
  | 'id'
  /** column name */
  | 'path'
  /** column name */
  | 'updated_at';

export type Preservation_Method_Enum =
  | 'FROZEN'
  | 'NONE'
  | 'REFRIGERATED';

/** Boolean expression to compare columns of type "preservation_method_enum". All fields are combined with logical 'AND'. */
export type Preservation_Method_Enum_Comparison_Exp = {
  _eq?: Preservation_Method_Enum | null | undefined;
  _in?: Array<Preservation_Method_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Preservation_Method_Enum | null | undefined;
  _nin?: Array<Preservation_Method_Enum> | null | undefined;
};

export type Privacy_Setting_Enum =
  | 'CONTRACTUALIZED'
  | 'EVERYONE'
  | 'NOBODY';

/** Boolean expression to compare columns of type "privacy_setting_enum". All fields are combined with logical 'AND'. */
export type Privacy_Setting_Enum_Comparison_Exp = {
  _eq?: Privacy_Setting_Enum | null | undefined;
  _in?: Array<Privacy_Setting_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Privacy_Setting_Enum | null | undefined;
  _nin?: Array<Privacy_Setting_Enum> | null | undefined;
};

export type Product_Aggregate_Bool_Exp = {
  bool_and?: Product_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Product_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Product_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Product_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Product_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Product_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Product_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  data: Array<Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: Product_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: Array<Product_Bool_Exp> | null | undefined;
  _not?: Product_Bool_Exp | null | undefined;
  _or?: Array<Product_Bool_Exp> | null | undefined;
  alcohol_by_volume?: Numeric_Comparison_Exp | null | undefined;
  allergens?: String_Comparison_Exp | null | undefined;
  base_units?: Base_Unit_Bool_Exp | null | undefined;
  base_units_aggregate?: Base_Unit_Aggregate_Bool_Exp | null | undefined;
  brand?: String_Comparison_Exp | null | undefined;
  calories?: Numeric_Comparison_Exp | null | undefined;
  calories_kj?: Numeric_Comparison_Exp | null | undefined;
  carbohydrate?: Numeric_Comparison_Exp | null | undefined;
  classification_tags?: Product_Classification_Tag_Assignment_Bool_Exp | null | undefined;
  classification_tags_aggregate?: Product_Classification_Tag_Assignment_Aggregate_Bool_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deleted_at?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  description?: String_Comparison_Exp | null | undefined;
  fat?: Numeric_Comparison_Exp | null | undefined;
  generic_product?: Product_Classification_Node_Bool_Exp | null | undefined;
  generic_product_code?: String_Comparison_Exp | null | undefined;
  generic_product_level?: String_Comparison_Exp | null | undefined;
  has_no_allergen_declaration?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  ingredients?: String_Comparison_Exp | null | undefined;
  is_exempt_from_ingredient_list?: Boolean_Comparison_Exp | null | undefined;
  labels?: Product_Product_Labels_Product_Label_Bool_Exp | null | undefined;
  labels_aggregate?: Product_Product_Labels_Product_Label_Aggregate_Bool_Exp | null | undefined;
  last_other_updated_date?: Timestamptz_Comparison_Exp | null | undefined;
  last_price_updated_date?: Timestamptz_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  packagings?: Packaging_Bool_Exp | null | undefined;
  packagings_aggregate?: Packaging_Aggregate_Bool_Exp | null | undefined;
  preservation_method?: Preservation_Method_Enum_Comparison_Exp | null | undefined;
  product_naming_validation?: Product_Naming_Validation_Bool_Exp | null | undefined;
  product_sub_family?: Product_Sub_Family_Bool_Exp | null | undefined;
  protein?: Numeric_Comparison_Exp | null | undefined;
  saturated_fat?: Numeric_Comparison_Exp | null | undefined;
  shelf_life_duration?: Numeric_Comparison_Exp | null | undefined;
  shelf_life_duration_type?: Duration_Type_Enum_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  sodium?: Numeric_Comparison_Exp | null | undefined;
  sub_family?: String_Comparison_Exp | null | undefined;
  sugars?: Numeric_Comparison_Exp | null | undefined;
  vat_rate?: Numeric_Comparison_Exp | null | undefined;
};

/** Boolean expression to filter rows from the table "product_classification_level". All fields are combined with a logical 'AND'. */
export type Product_Classification_Level_Bool_Exp = {
  _and?: Array<Product_Classification_Level_Bool_Exp> | null | undefined;
  _not?: Product_Classification_Level_Bool_Exp | null | undefined;
  _or?: Array<Product_Classification_Level_Bool_Exp> | null | undefined;
  comment?: String_Comparison_Exp | null | undefined;
  value?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_classification_level" */
export type Product_Classification_Level_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_classification_level_pkey';

export type Product_Classification_Level_Enum =
  /** Rayon */
  | 'FAMILY'
  /** Nature du produit */
  | 'GENERIC_PRODUCT'
  /** Sous-famille */
  | 'MICRO_FAMILY'
  /** Famille */
  | 'SUB_FAMILY';

/** Boolean expression to compare columns of type "product_classification_level_enum". All fields are combined with logical 'AND'. */
export type Product_Classification_Level_Enum_Comparison_Exp = {
  _eq?: Product_Classification_Level_Enum | null | undefined;
  _in?: Array<Product_Classification_Level_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Product_Classification_Level_Enum | null | undefined;
  _nin?: Array<Product_Classification_Level_Enum> | null | undefined;
};

/** input type for inserting data into table "product_classification_level" */
export type Product_Classification_Level_Insert_Input = {
  comment?: string | null | undefined;
  value?: string | null | undefined;
};

/** input type for inserting object relation for remote table "product_classification_level" */
export type Product_Classification_Level_Obj_Rel_Insert_Input = {
  data: Product_Classification_Level_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Classification_Level_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_classification_level" */
export type Product_Classification_Level_On_Conflict = {
  constraint: Product_Classification_Level_Constraint;
  update_columns?: Array<Product_Classification_Level_Update_Column>;
  where?: Product_Classification_Level_Bool_Exp | null | undefined;
};

/** update columns of table "product_classification_level" */
export type Product_Classification_Level_Update_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'value';

export type Product_Classification_Node_Aggregate_Bool_Exp = {
  count?: Product_Classification_Node_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Product_Classification_Node_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Product_Classification_Node_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Product_Classification_Node_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "product_classification_node" */
export type Product_Classification_Node_Arr_Rel_Insert_Input = {
  data: Array<Product_Classification_Node_Insert_Input>;
  /** upsert condition */
  on_conflict?: Product_Classification_Node_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "product_classification_node". All fields are combined with a logical 'AND'. */
export type Product_Classification_Node_Bool_Exp = {
  _and?: Array<Product_Classification_Node_Bool_Exp> | null | undefined;
  _not?: Product_Classification_Node_Bool_Exp | null | undefined;
  _or?: Array<Product_Classification_Node_Bool_Exp> | null | undefined;
  children?: Product_Classification_Node_Bool_Exp | null | undefined;
  children_aggregate?: Product_Classification_Node_Aggregate_Bool_Exp | null | undefined;
  classified_products?: Product_Bool_Exp | null | undefined;
  classified_products_aggregate?: Product_Aggregate_Bool_Exp | null | undefined;
  code?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  level?: Product_Classification_Level_Enum_Comparison_Exp | null | undefined;
  parent?: Product_Classification_Node_Bool_Exp | null | undefined;
  parent_code?: String_Comparison_Exp | null | undefined;
  parent_level?: String_Comparison_Exp | null | undefined;
  product_classification_level?: Product_Classification_Level_Bool_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_classification_node" */
export type Product_Classification_Node_Constraint =
  /** unique or primary key constraint on columns "code", "level" */
  | 'product_classification_node_pkey';

/** input type for inserting data into table "product_classification_node" */
export type Product_Classification_Node_Insert_Input = {
  children?: Product_Classification_Node_Arr_Rel_Insert_Input | null | undefined;
  classified_products?: Product_Arr_Rel_Insert_Input | null | undefined;
  code?: string | null | undefined;
  created_at?: string | null | undefined;
  level?: Product_Classification_Level_Enum | null | undefined;
  parent?: Product_Classification_Node_Obj_Rel_Insert_Input | null | undefined;
  parent_code?: string | null | undefined;
  product_classification_level?: Product_Classification_Level_Obj_Rel_Insert_Input | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "product_classification_node" */
export type Product_Classification_Node_Obj_Rel_Insert_Input = {
  data: Product_Classification_Node_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Classification_Node_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_classification_node" */
export type Product_Classification_Node_On_Conflict = {
  constraint: Product_Classification_Node_Constraint;
  update_columns?: Array<Product_Classification_Node_Update_Column>;
  where?: Product_Classification_Node_Bool_Exp | null | undefined;
};

/** select columns of table "product_classification_node" */
export type Product_Classification_Node_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'level'
  /** column name */
  | 'parent_code'
  /** column name */
  | 'parent_level'
  /** column name */
  | 'updated_at';

/** update columns of table "product_classification_node" */
export type Product_Classification_Node_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'level'
  /** column name */
  | 'parent_code'
  /** column name */
  | 'updated_at';

export type Product_Classification_Tag_Assignment_Aggregate_Bool_Exp = {
  count?: Product_Classification_Tag_Assignment_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Product_Classification_Tag_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Product_Classification_Tag_Assignment_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Product_Classification_Tag_Assignment_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_Arr_Rel_Insert_Input = {
  data: Array<Product_Classification_Tag_Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Product_Classification_Tag_Assignment_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "product_classification_tag_assignment". All fields are combined with a logical 'AND'. */
export type Product_Classification_Tag_Assignment_Bool_Exp = {
  _and?: Array<Product_Classification_Tag_Assignment_Bool_Exp> | null | undefined;
  _not?: Product_Classification_Tag_Assignment_Bool_Exp | null | undefined;
  _or?: Array<Product_Classification_Tag_Assignment_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  product?: Product_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  tag?: Product_Classification_Tag_Bool_Exp | null | undefined;
  tag_code?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_Constraint =
  /** unique or primary key constraint on columns "product_id", "tag_code" */
  | 'product_classification_tag_assignment_pkey';

/** input type for inserting data into table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_Insert_Input = {
  created_at?: string | null | undefined;
  product?: Product_Obj_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  tag?: Product_Classification_Tag_Obj_Rel_Insert_Input | null | undefined;
  tag_code?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_On_Conflict = {
  constraint: Product_Classification_Tag_Assignment_Constraint;
  update_columns?: Array<Product_Classification_Tag_Assignment_Update_Column>;
  where?: Product_Classification_Tag_Assignment_Bool_Exp | null | undefined;
};

/** select columns of table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'product_id'
  /** column name */
  | 'tag_code'
  /** column name */
  | 'updated_at';

/** update columns of table "product_classification_tag_assignment" */
export type Product_Classification_Tag_Assignment_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'product_id'
  /** column name */
  | 'tag_code'
  /** column name */
  | 'updated_at';

/** Boolean expression to filter rows from the table "product_classification_tag". All fields are combined with a logical 'AND'. */
export type Product_Classification_Tag_Bool_Exp = {
  _and?: Array<Product_Classification_Tag_Bool_Exp> | null | undefined;
  _not?: Product_Classification_Tag_Bool_Exp | null | undefined;
  _or?: Array<Product_Classification_Tag_Bool_Exp> | null | undefined;
  assigned_products?: Product_Classification_Tag_Assignment_Bool_Exp | null | undefined;
  assigned_products_aggregate?: Product_Classification_Tag_Assignment_Aggregate_Bool_Exp | null | undefined;
  code?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  product_classification_tag_group?: Product_Classification_Tag_Group_Bool_Exp | null | undefined;
  tag_group?: Product_Classification_Tag_Group_Enum_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_classification_tag" */
export type Product_Classification_Tag_Constraint =
  /** unique or primary key constraint on columns "code" */
  | 'product_classification_tag_pkey';

/** Boolean expression to filter rows from the table "product_classification_tag_group". All fields are combined with a logical 'AND'. */
export type Product_Classification_Tag_Group_Bool_Exp = {
  _and?: Array<Product_Classification_Tag_Group_Bool_Exp> | null | undefined;
  _not?: Product_Classification_Tag_Group_Bool_Exp | null | undefined;
  _or?: Array<Product_Classification_Tag_Group_Bool_Exp> | null | undefined;
  comment?: String_Comparison_Exp | null | undefined;
  value?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_classification_tag_group" */
export type Product_Classification_Tag_Group_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_classification_tag_group_pkey';

export type Product_Classification_Tag_Group_Enum =
  /** Événement */
  | 'EVENEMENT'
  /** Moments de consommation */
  | 'MOMENTS_CONSOMMATION'
  /** Produits du Monde */
  | 'PRODUITS_DU_MONDE'
  /** Régimes alimentaires */
  | 'REGIMES_ALIMENTAIRES'
  /** Valeurs et engagements */
  | 'VALEURS_ENGAGEMENTS';

/** Boolean expression to compare columns of type "product_classification_tag_group_enum". All fields are combined with logical 'AND'. */
export type Product_Classification_Tag_Group_Enum_Comparison_Exp = {
  _eq?: Product_Classification_Tag_Group_Enum | null | undefined;
  _in?: Array<Product_Classification_Tag_Group_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Product_Classification_Tag_Group_Enum | null | undefined;
  _nin?: Array<Product_Classification_Tag_Group_Enum> | null | undefined;
};

/** input type for inserting data into table "product_classification_tag_group" */
export type Product_Classification_Tag_Group_Insert_Input = {
  comment?: string | null | undefined;
  value?: string | null | undefined;
};

/** input type for inserting object relation for remote table "product_classification_tag_group" */
export type Product_Classification_Tag_Group_Obj_Rel_Insert_Input = {
  data: Product_Classification_Tag_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Classification_Tag_Group_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_classification_tag_group" */
export type Product_Classification_Tag_Group_On_Conflict = {
  constraint: Product_Classification_Tag_Group_Constraint;
  update_columns?: Array<Product_Classification_Tag_Group_Update_Column>;
  where?: Product_Classification_Tag_Group_Bool_Exp | null | undefined;
};

/** update columns of table "product_classification_tag_group" */
export type Product_Classification_Tag_Group_Update_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'value';

/** input type for inserting data into table "product_classification_tag" */
export type Product_Classification_Tag_Insert_Input = {
  assigned_products?: Product_Classification_Tag_Assignment_Arr_Rel_Insert_Input | null | undefined;
  code?: string | null | undefined;
  created_at?: string | null | undefined;
  product_classification_tag_group?: Product_Classification_Tag_Group_Obj_Rel_Insert_Input | null | undefined;
  tag_group?: Product_Classification_Tag_Group_Enum | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "product_classification_tag" */
export type Product_Classification_Tag_Obj_Rel_Insert_Input = {
  data: Product_Classification_Tag_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Classification_Tag_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_classification_tag" */
export type Product_Classification_Tag_On_Conflict = {
  constraint: Product_Classification_Tag_Constraint;
  update_columns?: Array<Product_Classification_Tag_Update_Column>;
  where?: Product_Classification_Tag_Bool_Exp | null | undefined;
};

/** update columns of table "product_classification_tag" */
export type Product_Classification_Tag_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'tag_group'
  /** column name */
  | 'updated_at';

/** unique or primary key constraints on table "product" */
export type Product_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_bebc9158e480b949565b4dc7a82'
  /** unique or primary key constraint on columns "sku", "company_id" */
  | 'product_sku_company_id_unique';

export type Product_Family_Name_Enum =
  | 'BEVERAGES'
  | 'FRESH_FOOD'
  | 'GROCERY'
  | 'NON_FOOD_PRODUCTS';

/** Boolean expression to compare columns of type "product_family_name_enum". All fields are combined with logical 'AND'. */
export type Product_Family_Name_Enum_Comparison_Exp = {
  _eq?: Product_Family_Name_Enum | null | undefined;
  _in?: Array<Product_Family_Name_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Product_Family_Name_Enum | null | undefined;
  _nin?: Array<Product_Family_Name_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "product_history". All fields are combined with a logical 'AND'. */
export type Product_History_Bool_Exp = {
  _and?: Array<Product_History_Bool_Exp> | null | undefined;
  _not?: Product_History_Bool_Exp | null | undefined;
  _or?: Array<Product_History_Bool_Exp> | null | undefined;
  alcohol_by_volume?: Numeric_Comparison_Exp | null | undefined;
  allergens?: String_Comparison_Exp | null | undefined;
  base_units?: Base_Unit_History_Bool_Exp | null | undefined;
  base_units_aggregate?: Base_Unit_History_Aggregate_Bool_Exp | null | undefined;
  brand?: String_Comparison_Exp | null | undefined;
  calories?: Numeric_Comparison_Exp | null | undefined;
  calories_kj?: Numeric_Comparison_Exp | null | undefined;
  carbohydrate?: Numeric_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  created_date?: Timestamptz_Comparison_Exp | null | undefined;
  deleted_at?: Timestamptz_Comparison_Exp | null | undefined;
  deprecated_sku?: String_Comparison_Exp | null | undefined;
  description?: String_Comparison_Exp | null | undefined;
  fat?: Numeric_Comparison_Exp | null | undefined;
  generic_product?: Product_Classification_Node_Bool_Exp | null | undefined;
  generic_product_code?: String_Comparison_Exp | null | undefined;
  generic_product_level?: String_Comparison_Exp | null | undefined;
  has_no_allergen_declaration?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  ingredients?: String_Comparison_Exp | null | undefined;
  is_exempt_from_ingredient_list?: Boolean_Comparison_Exp | null | undefined;
  labels?: Product_Product_Labels_Product_Label_Bool_Exp | null | undefined;
  labels_aggregate?: Product_Product_Labels_Product_Label_Aggregate_Bool_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  preservation_method?: Preservation_Method_Enum_Comparison_Exp | null | undefined;
  protein?: Numeric_Comparison_Exp | null | undefined;
  saturated_fat?: Numeric_Comparison_Exp | null | undefined;
  shelf_life_duration?: Numeric_Comparison_Exp | null | undefined;
  shelf_life_duration_type?: String_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  sodium?: Numeric_Comparison_Exp | null | undefined;
  sub_family?: String_Comparison_Exp | null | undefined;
  sugars?: Numeric_Comparison_Exp | null | undefined;
  vat_rate?: Numeric_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_history" */
export type Product_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_history_pkey';

/** input type for inserting data into table "product_history" */
export type Product_History_Insert_Input = {
  alcohol_by_volume?: number | null | undefined;
  allergens?: string | null | undefined;
  base_units?: Base_Unit_History_Arr_Rel_Insert_Input | null | undefined;
  brand?: string | null | undefined;
  calories?: number | null | undefined;
  calories_kj?: number | null | undefined;
  carbohydrate?: number | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  created_date?: string | null | undefined;
  deleted_at?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  description?: string | null | undefined;
  fat?: number | null | undefined;
  generic_product?: Product_Classification_Node_Obj_Rel_Insert_Input | null | undefined;
  generic_product_code?: string | null | undefined;
  generic_product_level?: string | null | undefined;
  has_no_allergen_declaration?: boolean | null | undefined;
  id?: string | null | undefined;
  ingredients?: string | null | undefined;
  is_exempt_from_ingredient_list?: boolean | null | undefined;
  labels?: Product_Product_Labels_Product_Label_Arr_Rel_Insert_Input | null | undefined;
  name?: string | null | undefined;
  preservation_method?: Preservation_Method_Enum | null | undefined;
  protein?: number | null | undefined;
  saturated_fat?: number | null | undefined;
  shelf_life_duration?: number | null | undefined;
  shelf_life_duration_type?: string | null | undefined;
  sku?: number | null | undefined;
  sodium?: number | null | undefined;
  sub_family?: string | null | undefined;
  sugars?: number | null | undefined;
  vat_rate?: number | null | undefined;
};

/** input type for inserting object relation for remote table "product_history" */
export type Product_History_Obj_Rel_Insert_Input = {
  data: Product_History_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_History_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_history" */
export type Product_History_On_Conflict = {
  constraint: Product_History_Constraint;
  update_columns?: Array<Product_History_Update_Column>;
  where?: Product_History_Bool_Exp | null | undefined;
};

/** update columns of table "product_history" */
export type Product_History_Update_Column =
  /** column name */
  | 'alcohol_by_volume'
  /** column name */
  | 'allergens'
  /** column name */
  | 'brand'
  /** column name */
  | 'calories'
  /** column name */
  | 'calories_kj'
  /** column name */
  | 'carbohydrate'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'description'
  /** column name */
  | 'fat'
  /** column name */
  | 'generic_product_code'
  /** column name */
  | 'generic_product_level'
  /** column name */
  | 'has_no_allergen_declaration'
  /** column name */
  | 'id'
  /** column name */
  | 'ingredients'
  /** column name */
  | 'is_exempt_from_ingredient_list'
  /** column name */
  | 'name'
  /** column name */
  | 'preservation_method'
  /** column name */
  | 'protein'
  /** column name */
  | 'saturated_fat'
  /** column name */
  | 'shelf_life_duration'
  /** column name */
  | 'shelf_life_duration_type'
  /** column name */
  | 'sku'
  /** column name */
  | 'sodium'
  /** column name */
  | 'sub_family'
  /** column name */
  | 'sugars'
  /** column name */
  | 'vat_rate';

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  alcohol_by_volume?: number | null | undefined;
  allergens?: string | null | undefined;
  base_units?: Base_Unit_Arr_Rel_Insert_Input | null | undefined;
  brand?: string | null | undefined;
  calories?: number | null | undefined;
  calories_kj?: number | null | undefined;
  carbohydrate?: number | null | undefined;
  classification_tags?: Product_Classification_Tag_Assignment_Arr_Rel_Insert_Input | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  created_date?: string | null | undefined;
  deleted_at?: string | null | undefined;
  deprecated_sku?: string | null | undefined;
  description?: string | null | undefined;
  fat?: number | null | undefined;
  generic_product?: Product_Classification_Node_Obj_Rel_Insert_Input | null | undefined;
  generic_product_code?: string | null | undefined;
  generic_product_level?: string | null | undefined;
  has_no_allergen_declaration?: boolean | null | undefined;
  id?: string | null | undefined;
  ingredients?: string | null | undefined;
  is_exempt_from_ingredient_list?: boolean | null | undefined;
  labels?: Product_Product_Labels_Product_Label_Arr_Rel_Insert_Input | null | undefined;
  name?: string | null | undefined;
  packagings?: Packaging_Arr_Rel_Insert_Input | null | undefined;
  preservation_method?: Preservation_Method_Enum | null | undefined;
  product_naming_validation?: Product_Naming_Validation_Obj_Rel_Insert_Input | null | undefined;
  product_sub_family?: Product_Sub_Family_Obj_Rel_Insert_Input | null | undefined;
  protein?: number | null | undefined;
  saturated_fat?: number | null | undefined;
  shelf_life_duration?: number | null | undefined;
  shelf_life_duration_type?: Duration_Type_Enum | null | undefined;
  sku?: number | null | undefined;
  sodium?: number | null | undefined;
  sub_family?: string | null | undefined;
  sugars?: number | null | undefined;
  vat_rate?: number | null | undefined;
};

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

/** Boolean expression to compare columns of type "product_label_name_enum". All fields are combined with logical 'AND'. */
export type Product_Label_Name_Enum_Comparison_Exp = {
  _eq?: Product_Label_Name_Enum | null | undefined;
  _in?: Array<Product_Label_Name_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Product_Label_Name_Enum | null | undefined;
  _nin?: Array<Product_Label_Name_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "product_naming_validation". All fields are combined with a logical 'AND'. */
export type Product_Naming_Validation_Bool_Exp = {
  _and?: Array<Product_Naming_Validation_Bool_Exp> | null | undefined;
  _not?: Product_Naming_Validation_Bool_Exp | null | undefined;
  _or?: Array<Product_Naming_Validation_Bool_Exp> | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  errors?: Jsonb_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  is_valid?: Boolean_Comparison_Exp | null | undefined;
  pending_validation?: Boolean_Comparison_Exp | null | undefined;
  product_history?: Product_History_Bool_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  rules_version?: String_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_naming_validation" */
export type Product_Naming_Validation_Constraint =
  /** unique or primary key constraint on columns "sku", "company_id" */
  | 'product_naming_validation_company_id_sku_key'
  /** unique or primary key constraint on columns "id" */
  | 'product_naming_validation_pkey';

/** input type for inserting data into table "product_naming_validation" */
export type Product_Naming_Validation_Insert_Input = {
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  errors?: { [key: string]: any } | null | null | undefined;
  id?: string | null | undefined;
  is_valid?: boolean | null | undefined;
  pending_validation?: boolean | null | undefined;
  product_history?: Product_History_Obj_Rel_Insert_Input | null | undefined;
  product_id?: string | null | undefined;
  rules_version?: string | null | undefined;
  sku?: number | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "product_naming_validation" */
export type Product_Naming_Validation_Obj_Rel_Insert_Input = {
  data: Product_Naming_Validation_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Naming_Validation_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_naming_validation" */
export type Product_Naming_Validation_On_Conflict = {
  constraint: Product_Naming_Validation_Constraint;
  update_columns?: Array<Product_Naming_Validation_Update_Column>;
  where?: Product_Naming_Validation_Bool_Exp | null | undefined;
};

/** update columns of table "product_naming_validation" */
export type Product_Naming_Validation_Update_Column =
  /** column name */
  | 'company_id'
  /** column name */
  | 'errors'
  /** column name */
  | 'id'
  /** column name */
  | 'is_valid'
  /** column name */
  | 'pending_validation'
  /** column name */
  | 'product_id'
  /** column name */
  | 'rules_version'
  /** column name */
  | 'sku'
  /** column name */
  | 'updated_at';

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: Product_Bool_Exp | null | undefined;
};

export type Product_Product_Labels_Product_Label_Aggregate_Bool_Exp = {
  count?: Product_Product_Labels_Product_Label_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Product_Product_Labels_Product_Label_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Product_Product_Labels_Product_Label_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Product_Product_Labels_Product_Label_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_Arr_Rel_Insert_Input = {
  data: Array<Product_Product_Labels_Product_Label_Insert_Input>;
  /** upsert condition */
  on_conflict?: Product_Product_Labels_Product_Label_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "product_product_labels_product_label". All fields are combined with a logical 'AND'. */
export type Product_Product_Labels_Product_Label_Bool_Exp = {
  _and?: Array<Product_Product_Labels_Product_Label_Bool_Exp> | null | undefined;
  _not?: Product_Product_Labels_Product_Label_Bool_Exp | null | undefined;
  _or?: Array<Product_Product_Labels_Product_Label_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  label?: Product_Label_Name_Enum_Comparison_Exp | null | undefined;
  product_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_Constraint =
  /** unique or primary key constraint on columns "product_id", "label" */
  | 'product_product_labels_product_label_pkey';

/** input type for inserting data into table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_Insert_Input = {
  created_at?: string | null | undefined;
  label?: Product_Label_Name_Enum | null | undefined;
  product_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_On_Conflict = {
  constraint: Product_Product_Labels_Product_Label_Constraint;
  update_columns?: Array<Product_Product_Labels_Product_Label_Update_Column>;
  where?: Product_Product_Labels_Product_Label_Bool_Exp | null | undefined;
};

/** select columns of table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'label'
  /** column name */
  | 'product_id'
  /** column name */
  | 'updated_at';

/** update columns of table "product_product_labels_product_label" */
export type Product_Product_Labels_Product_Label_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'label'
  /** column name */
  | 'product_id'
  /** column name */
  | 'updated_at';

/** select columns of table "product" */
export type Product_Select_Column =
  /** column name */
  | 'alcohol_by_volume'
  /** column name */
  | 'allergens'
  /** column name */
  | 'brand'
  /** column name */
  | 'calories'
  /** column name */
  | 'calories_kj'
  /** column name */
  | 'carbohydrate'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'description'
  /** column name */
  | 'fat'
  /** column name */
  | 'generic_product_code'
  /** column name */
  | 'generic_product_level'
  /** column name */
  | 'has_no_allergen_declaration'
  /** column name */
  | 'id'
  /** column name */
  | 'ingredients'
  /** column name */
  | 'is_exempt_from_ingredient_list'
  /** column name */
  | 'name'
  /** column name */
  | 'preservation_method'
  /** column name */
  | 'protein'
  /** column name */
  | 'saturated_fat'
  /** column name */
  | 'shelf_life_duration'
  /** column name */
  | 'shelf_life_duration_type'
  /** column name */
  | 'sku'
  /** column name */
  | 'sodium'
  /** column name */
  | 'sub_family'
  /** column name */
  | 'sugars'
  /** column name */
  | 'vat_rate';

/** select "product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product" */
export type Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'has_no_allergen_declaration'
  /** column name */
  | 'is_exempt_from_ingredient_list';

/** select "product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product" */
export type Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'has_no_allergen_declaration'
  /** column name */
  | 'is_exempt_from_ingredient_list';

export type Product_Sub_Family_Aggregate_Bool_Exp = {
  count?: Product_Sub_Family_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Product_Sub_Family_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Product_Sub_Family_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Product_Sub_Family_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "product_sub_family" */
export type Product_Sub_Family_Arr_Rel_Insert_Input = {
  data: Array<Product_Sub_Family_Insert_Input>;
  /** upsert condition */
  on_conflict?: Product_Sub_Family_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "product_sub_family". All fields are combined with a logical 'AND'. */
export type Product_Sub_Family_Bool_Exp = {
  _and?: Array<Product_Sub_Family_Bool_Exp> | null | undefined;
  _not?: Product_Sub_Family_Bool_Exp | null | undefined;
  _or?: Array<Product_Sub_Family_Bool_Exp> | null | undefined;
  name?: Product_Sub_Family_Name_Enum_Comparison_Exp | null | undefined;
  product_family_name?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "product_sub_family" */
export type Product_Sub_Family_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'product_sub_family_pkey';

/** input type for inserting data into table "product_sub_family" */
export type Product_Sub_Family_Insert_Input = {
  name?: Product_Sub_Family_Name_Enum | null | undefined;
  product_family_name?: string | null | undefined;
};

export type Product_Sub_Family_Name_Enum =
  | 'BAKERY'
  | 'BEER_CIDER'
  | 'CLOTHING_TEXTILE'
  | 'DAIRY'
  | 'DELI'
  | 'FISH_SEAFOOD'
  | 'FLORAL'
  | 'FROZEN_FOOD'
  | 'FRUITS'
  /**   */
  | 'GAMES_TOYS'
  | 'HOUSEHOLD_CLEANING'
  | 'HYGIENE_BEAUTY'
  | 'NON_ALCOHOLIC_BEVERAGES'
  | 'PETS'
  | 'RAW_MEAT'
  | 'SALTY_GROCERY'
  | 'SPIRITS'
  | 'SWEET_GROCERY'
  | 'VEGETABLES'
  | 'VEGETARIAN_VEGAN'
  | 'WINE_CHAMPAGNE_SPARKLING';

/** Boolean expression to compare columns of type "product_sub_family_name_enum". All fields are combined with logical 'AND'. */
export type Product_Sub_Family_Name_Enum_Comparison_Exp = {
  _eq?: Product_Sub_Family_Name_Enum | null | undefined;
  _in?: Array<Product_Sub_Family_Name_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Product_Sub_Family_Name_Enum | null | undefined;
  _nin?: Array<Product_Sub_Family_Name_Enum> | null | undefined;
};

/** input type for inserting object relation for remote table "product_sub_family" */
export type Product_Sub_Family_Obj_Rel_Insert_Input = {
  data: Product_Sub_Family_Insert_Input;
  /** upsert condition */
  on_conflict?: Product_Sub_Family_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "product_sub_family" */
export type Product_Sub_Family_On_Conflict = {
  constraint: Product_Sub_Family_Constraint;
  update_columns?: Array<Product_Sub_Family_Update_Column>;
  where?: Product_Sub_Family_Bool_Exp | null | undefined;
};

/** select columns of table "product_sub_family" */
export type Product_Sub_Family_Select_Column =
  /** column name */
  | 'name'
  /** column name */
  | 'product_family_name';

/** update columns of table "product_sub_family" */
export type Product_Sub_Family_Update_Column =
  /** column name */
  | 'name'
  /** column name */
  | 'product_family_name';

/** update columns of table "product" */
export type Product_Update_Column =
  /** column name */
  | 'alcohol_by_volume'
  /** column name */
  | 'allergens'
  /** column name */
  | 'brand'
  /** column name */
  | 'calories'
  /** column name */
  | 'calories_kj'
  /** column name */
  | 'carbohydrate'
  /** column name */
  | 'company_id'
  /** column name */
  | 'created_date'
  /** column name */
  | 'deleted_at'
  /** column name */
  | 'deprecated_sku'
  /** column name */
  | 'description'
  /** column name */
  | 'fat'
  /** column name */
  | 'generic_product_code'
  /** column name */
  | 'generic_product_level'
  /** column name */
  | 'has_no_allergen_declaration'
  /** column name */
  | 'id'
  /** column name */
  | 'ingredients'
  /** column name */
  | 'is_exempt_from_ingredient_list'
  /** column name */
  | 'name'
  /** column name */
  | 'preservation_method'
  /** column name */
  | 'protein'
  /** column name */
  | 'saturated_fat'
  /** column name */
  | 'shelf_life_duration'
  /** column name */
  | 'shelf_life_duration_type'
  /** column name */
  | 'sku'
  /** column name */
  | 'sodium'
  /** column name */
  | 'sub_family'
  /** column name */
  | 'sugars'
  /** column name */
  | 'vat_rate';

export type Received_Email_Aggregate_Bool_Exp = {
  bool_and?: Received_Email_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Received_Email_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Received_Email_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Received_Email_Aggregate_Bool_Exp_Bool_And = {
  arguments: Received_Email_Select_Column_Received_Email_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Received_Email_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Received_Email_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Received_Email_Select_Column_Received_Email_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Received_Email_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Received_Email_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Received_Email_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Received_Email_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "received_email" */
export type Received_Email_Arr_Rel_Insert_Input = {
  data: Array<Received_Email_Insert_Input>;
  /** upsert condition */
  on_conflict?: Received_Email_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "received_email". All fields are combined with a logical 'AND'. */
export type Received_Email_Bool_Exp = {
  _and?: Array<Received_Email_Bool_Exp> | null | undefined;
  _not?: Received_Email_Bool_Exp | null | undefined;
  _or?: Array<Received_Email_Bool_Exp> | null | undefined;
  contract?: Contract_History_Bool_Exp | null | undefined;
  contract_id?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  document?: Document_Bool_Exp | null | undefined;
  document_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  is_discarded?: Boolean_Comparison_Exp | null | undefined;
  params?: Jsonb_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "received_email" */
export type Received_Email_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'received_email_pkey';

/** input type for inserting data into table "received_email" */
export type Received_Email_Insert_Input = {
  contract?: Contract_History_Obj_Rel_Insert_Input | null | undefined;
  contract_id?: string | null | undefined;
  created_at?: string | null | undefined;
  document?: Document_Obj_Rel_Insert_Input | null | undefined;
  document_id?: string | null | undefined;
  id?: string | null | undefined;
  is_discarded?: boolean | null | undefined;
  params?: { [key: string]: any } | null | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "received_email" */
export type Received_Email_On_Conflict = {
  constraint: Received_Email_Constraint;
  update_columns?: Array<Received_Email_Update_Column>;
  where?: Received_Email_Bool_Exp | null | undefined;
};

/** select columns of table "received_email" */
export type Received_Email_Select_Column =
  /** column name */
  | 'contract_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'document_id'
  /** column name */
  | 'id'
  /** column name */
  | 'is_discarded'
  /** column name */
  | 'params'
  /** column name */
  | 'updated_at';

/** select "received_email_aggregate_bool_exp_bool_and_arguments_columns" columns of table "received_email" */
export type Received_Email_Select_Column_Received_Email_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_discarded';

/** select "received_email_aggregate_bool_exp_bool_or_arguments_columns" columns of table "received_email" */
export type Received_Email_Select_Column_Received_Email_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_discarded';

/** update columns of table "received_email" */
export type Received_Email_Update_Column =
  /** column name */
  | 'contract_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'document_id'
  /** column name */
  | 'id'
  /** column name */
  | 'is_discarded'
  /** column name */
  | 'params'
  /** column name */
  | 'updated_at';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

/** Boolean expression to compare columns of type "return_policy_enum". All fields are combined with logical 'AND'. */
export type Return_Policy_Enum_Comparison_Exp = {
  _eq?: Return_Policy_Enum | null | undefined;
  _in?: Array<Return_Policy_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Return_Policy_Enum | null | undefined;
  _nin?: Array<Return_Policy_Enum> | null | undefined;
};

export type Role_Assignment_Administrative_Area_Aggregate_Bool_Exp = {
  bool_and?: Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Assignment_Administrative_Area_Select_Column_Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Assignment_Administrative_Area_Select_Column_Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Role_Assignment_Administrative_Area_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Arr_Rel_Insert_Input = {
  data: Array<Role_Assignment_Administrative_Area_Insert_Input>;
  /** upsert condition */
  on_conflict?: Role_Assignment_Administrative_Area_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "role_assignment_administrative_area". All fields are combined with a logical 'AND'. */
export type Role_Assignment_Administrative_Area_Bool_Exp = {
  _and?: Array<Role_Assignment_Administrative_Area_Bool_Exp> | null | undefined;
  _not?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
  _or?: Array<Role_Assignment_Administrative_Area_Bool_Exp> | null | undefined;
  area?: String_Comparison_Exp | null | undefined;
  country_code?: String_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  has_all_areas?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  role_assignment?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignment_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'role_assignment_administrative_area_pkey';

/** input type for inserting data into table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Insert_Input = {
  area?: string | null | undefined;
  country_code?: string | null | undefined;
  created_at?: string | null | undefined;
  has_all_areas?: boolean | null | undefined;
  id?: string | null | undefined;
  role_assignment?: Role_Assignment_Obj_Rel_Insert_Input | null | undefined;
  role_assignment_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_On_Conflict = {
  constraint: Role_Assignment_Administrative_Area_Constraint;
  update_columns?: Array<Role_Assignment_Administrative_Area_Update_Column>;
  where?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
};

/** select columns of table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Select_Column =
  /** column name */
  | 'area'
  /** column name */
  | 'country_code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'has_all_areas'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

/** select "role_assignment_administrative_area_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Select_Column_Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'has_all_areas';

/** select "role_assignment_administrative_area_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Select_Column_Role_Assignment_Administrative_Area_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'has_all_areas';

/** update columns of table "role_assignment_administrative_area" */
export type Role_Assignment_Administrative_Area_Update_Column =
  /** column name */
  | 'area'
  /** column name */
  | 'country_code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'has_all_areas'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

export type Role_Assignment_Aggregate_Bool_Exp = {
  bool_and?: Role_Assignment_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Role_Assignment_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Role_Assignment_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Role_Assignment_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Assignment_Select_Column_Role_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Assignment_Select_Column_Role_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Role_Assignment_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "role_assignment" */
export type Role_Assignment_Arr_Rel_Insert_Input = {
  data: Array<Role_Assignment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Role_Assignment_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "role_assignment". All fields are combined with a logical 'AND'. */
export type Role_Assignment_Bool_Exp = {
  _and?: Array<Role_Assignment_Bool_Exp> | null | undefined;
  _not?: Role_Assignment_Bool_Exp | null | undefined;
  _or?: Array<Role_Assignment_Bool_Exp> | null | undefined;
  administrative_areas?: Role_Assignment_Administrative_Area_Bool_Exp | null | undefined;
  administrative_areas_aggregate?: Role_Assignment_Administrative_Area_Aggregate_Bool_Exp | null | undefined;
  brands?: Role_Assignment_Brand_Bool_Exp | null | undefined;
  brands_aggregate?: Role_Assignment_Brand_Aggregate_Bool_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  companyId?: Uuid_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  is_delivery_contact?: Boolean_Comparison_Exp | null | undefined;
  is_invoicing_contact?: Boolean_Comparison_Exp | null | undefined;
  notification_subscription?: Notification_Subscription_Bool_Exp | null | undefined;
  notification_subscription_aggregate?: Notification_Subscription_Aggregate_Bool_Exp | null | undefined;
  product_families?: User_Product_Family_Bool_Exp | null | undefined;
  product_families_aggregate?: User_Product_Family_Aggregate_Bool_Exp | null | undefined;
  role?: Role_Bool_Exp | null | undefined;
  roleId?: Uuid_Comparison_Exp | null | undefined;
  role_name?: User_Role_Enum_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
  userId?: Uuid_Comparison_Exp | null | undefined;
  wishlist_items?: Wishlist_Item_Bool_Exp | null | undefined;
  wishlist_items_aggregate?: Wishlist_Item_Aggregate_Bool_Exp | null | undefined;
};

export type Role_Assignment_Brand_Aggregate_Bool_Exp = {
  bool_and?: Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_And | null | undefined;
  bool_or?: Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_Or | null | undefined;
  count?: Role_Assignment_Brand_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Assignment_Brand_Select_Column_Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Brand_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Assignment_Brand_Select_Column_Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Brand_Bool_Exp | null | undefined;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Assignment_Brand_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Role_Assignment_Brand_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Role_Assignment_Brand_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "role_assignment_brand" */
export type Role_Assignment_Brand_Arr_Rel_Insert_Input = {
  data: Array<Role_Assignment_Brand_Insert_Input>;
  /** upsert condition */
  on_conflict?: Role_Assignment_Brand_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "role_assignment_brand". All fields are combined with a logical 'AND'. */
export type Role_Assignment_Brand_Bool_Exp = {
  _and?: Array<Role_Assignment_Brand_Bool_Exp> | null | undefined;
  _not?: Role_Assignment_Brand_Bool_Exp | null | undefined;
  _or?: Array<Role_Assignment_Brand_Bool_Exp> | null | undefined;
  brand?: Brand_Enum_Comparison_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  has_all_brands?: Boolean_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  role_assignment?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignment_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "role_assignment_brand" */
export type Role_Assignment_Brand_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'role_assignment_brand_pkey';

/** input type for inserting data into table "role_assignment_brand" */
export type Role_Assignment_Brand_Insert_Input = {
  brand?: Brand_Enum | null | undefined;
  created_at?: string | null | undefined;
  has_all_brands?: boolean | null | undefined;
  id?: string | null | undefined;
  role_assignment?: Role_Assignment_Obj_Rel_Insert_Input | null | undefined;
  role_assignment_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "role_assignment_brand" */
export type Role_Assignment_Brand_On_Conflict = {
  constraint: Role_Assignment_Brand_Constraint;
  update_columns?: Array<Role_Assignment_Brand_Update_Column>;
  where?: Role_Assignment_Brand_Bool_Exp | null | undefined;
};

/** select columns of table "role_assignment_brand" */
export type Role_Assignment_Brand_Select_Column =
  /** column name */
  | 'brand'
  /** column name */
  | 'created_at'
  /** column name */
  | 'has_all_brands'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

/** select "role_assignment_brand_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_assignment_brand" */
export type Role_Assignment_Brand_Select_Column_Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'has_all_brands';

/** select "role_assignment_brand_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_assignment_brand" */
export type Role_Assignment_Brand_Select_Column_Role_Assignment_Brand_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'has_all_brands';

/** update columns of table "role_assignment_brand" */
export type Role_Assignment_Brand_Update_Column =
  /** column name */
  | 'brand'
  /** column name */
  | 'created_at'
  /** column name */
  | 'has_all_brands'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

/** unique or primary key constraints on table "role_assignment" */
export type Role_Assignment_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_7e79671a8a5db18936173148cb4'
  /** unique or primary key constraint on columns "userId", "role_name", "companyId" */
  | 'role_assignment_userId_companyId_role_name_key';

/** input type for inserting data into table "role_assignment" */
export type Role_Assignment_Insert_Input = {
  administrative_areas?: Role_Assignment_Administrative_Area_Arr_Rel_Insert_Input | null | undefined;
  brands?: Role_Assignment_Brand_Arr_Rel_Insert_Input | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  companyId?: string | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  is_delivery_contact?: boolean | null | undefined;
  is_invoicing_contact?: boolean | null | undefined;
  notification_subscription?: Notification_Subscription_Arr_Rel_Insert_Input | null | undefined;
  product_families?: User_Product_Family_Arr_Rel_Insert_Input | null | undefined;
  role?: Role_Obj_Rel_Insert_Input | null | undefined;
  roleId?: string | null | undefined;
  role_name?: User_Role_Enum | null | undefined;
  updated_at?: string | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
  userId?: string | null | undefined;
  wishlist_items?: Wishlist_Item_Arr_Rel_Insert_Input | null | undefined;
};

/** input type for inserting object relation for remote table "role_assignment" */
export type Role_Assignment_Obj_Rel_Insert_Input = {
  data: Role_Assignment_Insert_Input;
  /** upsert condition */
  on_conflict?: Role_Assignment_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "role_assignment" */
export type Role_Assignment_On_Conflict = {
  constraint: Role_Assignment_Constraint;
  update_columns?: Array<Role_Assignment_Update_Column>;
  where?: Role_Assignment_Bool_Exp | null | undefined;
};

/** select columns of table "role_assignment" */
export type Role_Assignment_Select_Column =
  /** column name */
  | 'companyId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'is_delivery_contact'
  /** column name */
  | 'is_invoicing_contact'
  /** column name */
  | 'roleId'
  /** column name */
  | 'role_name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'userId';

/** select "role_assignment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_assignment" */
export type Role_Assignment_Select_Column_Role_Assignment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_delivery_contact'
  /** column name */
  | 'is_invoicing_contact';

/** select "role_assignment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_assignment" */
export type Role_Assignment_Select_Column_Role_Assignment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_delivery_contact'
  /** column name */
  | 'is_invoicing_contact';

/** update columns of table "role_assignment" */
export type Role_Assignment_Update_Column =
  /** column name */
  | 'companyId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'is_delivery_contact'
  /** column name */
  | 'is_invoicing_contact'
  /** column name */
  | 'roleId'
  /** column name */
  | 'role_name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'userId';

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: Array<Role_Bool_Exp> | null | undefined;
  _not?: Role_Bool_Exp | null | undefined;
  _or?: Array<Role_Bool_Exp> | null | undefined;
  businessProfile?: Business_Profile_Enum_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "role" */
export type Role_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_b36bcfe02fc8de3c57a8b2391c2'
  /** unique or primary key constraint on columns "businessProfile", "name" */
  | 'UQ_b65354c6af446b5cb5dfc2173a1';

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  businessProfile?: Business_Profile_Enum | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: Role_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: Role_Bool_Exp | null | undefined;
};

/** update columns of table "role" */
export type Role_Update_Column =
  /** column name */
  | 'businessProfile'
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Social_Tag_Aggregate_Bool_Exp = {
  count?: Social_Tag_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Social_Tag_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Social_Tag_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Social_Tag_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "social_tag" */
export type Social_Tag_Arr_Rel_Insert_Input = {
  data: Array<Social_Tag_Insert_Input>;
  /** upsert condition */
  on_conflict?: Social_Tag_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "social_tag". All fields are combined with a logical 'AND'. */
export type Social_Tag_Bool_Exp = {
  _and?: Array<Social_Tag_Bool_Exp> | null | undefined;
  _not?: Social_Tag_Bool_Exp | null | undefined;
  _or?: Array<Social_Tag_Bool_Exp> | null | undefined;
  base_unit?: Base_Unit_Bool_Exp | null | undefined;
  base_unit_sku?: Int_Comparison_Exp | null | undefined;
  company?: Company_Bool_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  level?: Int_Comparison_Exp | null | undefined;
  priority?: Int_Comparison_Exp | null | undefined;
  type?: Social_Tag_Type_Enum_Comparison_Exp | null | undefined;
  values?: Jsonb_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "social_tag" */
export type Social_Tag_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'social_tag_pkey';

/** input type for inserting data into table "social_tag" */
export type Social_Tag_Insert_Input = {
  base_unit?: Base_Unit_Obj_Rel_Insert_Input | null | undefined;
  base_unit_sku?: number | null | undefined;
  company?: Company_Obj_Rel_Insert_Input | null | undefined;
  company_id?: string | null | undefined;
  id?: string | null | undefined;
  level?: number | null | undefined;
  priority?: number | null | undefined;
  type?: Social_Tag_Type_Enum | null | undefined;
  values?: { [key: string]: any } | null | null | undefined;
};

/** on_conflict condition type for table "social_tag" */
export type Social_Tag_On_Conflict = {
  constraint: Social_Tag_Constraint;
  update_columns?: Array<Social_Tag_Update_Column>;
  where?: Social_Tag_Bool_Exp | null | undefined;
};

/** select columns of table "social_tag" */
export type Social_Tag_Select_Column =
  /** column name */
  | 'base_unit_sku'
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'level'
  /** column name */
  | 'priority'
  /** column name */
  | 'type'
  /** column name */
  | 'values';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

/** Boolean expression to compare columns of type "social_tag_type_enum". All fields are combined with logical 'AND'. */
export type Social_Tag_Type_Enum_Comparison_Exp = {
  _eq?: Social_Tag_Type_Enum | null | undefined;
  _in?: Array<Social_Tag_Type_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Social_Tag_Type_Enum | null | undefined;
  _nin?: Array<Social_Tag_Type_Enum> | null | undefined;
};

/** update columns of table "social_tag" */
export type Social_Tag_Update_Column =
  /** column name */
  | 'base_unit_sku'
  /** column name */
  | 'company_id'
  /** column name */
  | 'id'
  /** column name */
  | 'level'
  /** column name */
  | 'priority'
  /** column name */
  | 'type'
  /** column name */
  | 'values';

export type Staff_Role_Enum =
  | 'ADMIN';

/** Boolean expression to compare columns of type "staff_role_enum". All fields are combined with logical 'AND'. */
export type Staff_Role_Enum_Comparison_Exp = {
  _eq?: Staff_Role_Enum | null | undefined;
  _in?: Array<Staff_Role_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Staff_Role_Enum | null | undefined;
  _nin?: Array<Staff_Role_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "staff_user". All fields are combined with a logical 'AND'. */
export type Staff_User_Bool_Exp = {
  _and?: Array<Staff_User_Bool_Exp> | null | undefined;
  _not?: Staff_User_Bool_Exp | null | undefined;
  _or?: Array<Staff_User_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  email?: Citext_Comparison_Exp | null | undefined;
  first_name?: String_Comparison_Exp | null | undefined;
  google_id?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  last_name?: String_Comparison_Exp | null | undefined;
  picture?: String_Comparison_Exp | null | undefined;
  role?: Staff_Role_Enum_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
};

/** unique or primary key constraints on table "staff_user" */
export type Staff_User_Constraint =
  /** unique or primary key constraint on columns "email" */
  | 'staff_user_email_key'
  /** unique or primary key constraint on columns "id" */
  | 'staff_user_pkey';

/** input type for inserting data into table "staff_user" */
export type Staff_User_Insert_Input = {
  created_at?: string | null | undefined;
  email?: string | null | undefined;
  first_name?: string | null | undefined;
  google_id?: string | null | undefined;
  id?: string | null | undefined;
  last_name?: string | null | undefined;
  picture?: string | null | undefined;
  role?: Staff_Role_Enum | null | undefined;
  updated_at?: string | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
};

/** input type for inserting object relation for remote table "staff_user" */
export type Staff_User_Obj_Rel_Insert_Input = {
  data: Staff_User_Insert_Input;
  /** upsert condition */
  on_conflict?: Staff_User_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "staff_user" */
export type Staff_User_On_Conflict = {
  constraint: Staff_User_Constraint;
  update_columns?: Array<Staff_User_Update_Column>;
  where?: Staff_User_Bool_Exp | null | undefined;
};

/** update columns of table "staff_user" */
export type Staff_User_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'email'
  /** column name */
  | 'first_name'
  /** column name */
  | 'google_id'
  /** column name */
  | 'id'
  /** column name */
  | 'last_name'
  /** column name */
  | 'picture'
  /** column name */
  | 'role'
  /** column name */
  | 'updated_at';

/** Boolean expression to filter rows from the table "sub_catalog". All fields are combined with a logical 'AND'. */
export type Sub_Catalog_Bool_Exp = {
  _and?: Array<Sub_Catalog_Bool_Exp> | null | undefined;
  _not?: Sub_Catalog_Bool_Exp | null | undefined;
  _or?: Array<Sub_Catalog_Bool_Exp> | null | undefined;
  contracts?: Contract_Bool_Exp | null | undefined;
  contracts_aggregate?: Contract_Aggregate_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  name?: String_Comparison_Exp | null | undefined;
  sub_catalog_packagings?: Sub_Catalog_Packaging_Bool_Exp | null | undefined;
  sub_catalog_packagings_aggregate?: Sub_Catalog_Packaging_Aggregate_Bool_Exp | null | undefined;
  supplier_company?: Company_Bool_Exp | null | undefined;
  supplier_company_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "sub_catalog" */
export type Sub_Catalog_Constraint =
  /** unique or primary key constraint on columns "name", "supplier_company_id" */
  | 'sub_catalog_name_supplier_company_id_uq'
  /** unique or primary key constraint on columns "id" */
  | 'sub_catalog_pkey';

/** input type for inserting data into table "sub_catalog" */
export type Sub_Catalog_Insert_Input = {
  contracts?: Contract_Arr_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  sub_catalog_packagings?: Sub_Catalog_Packaging_Arr_Rel_Insert_Input | null | undefined;
  supplier_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  supplier_company_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** input type for inserting object relation for remote table "sub_catalog" */
export type Sub_Catalog_Obj_Rel_Insert_Input = {
  data: Sub_Catalog_Insert_Input;
  /** upsert condition */
  on_conflict?: Sub_Catalog_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "sub_catalog" */
export type Sub_Catalog_On_Conflict = {
  constraint: Sub_Catalog_Constraint;
  update_columns?: Array<Sub_Catalog_Update_Column>;
  where?: Sub_Catalog_Bool_Exp | null | undefined;
};

export type Sub_Catalog_Packaging_Aggregate_Bool_Exp = {
  count?: Sub_Catalog_Packaging_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Sub_Catalog_Packaging_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Sub_Catalog_Packaging_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Sub_Catalog_Packaging_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_Arr_Rel_Insert_Input = {
  data: Array<Sub_Catalog_Packaging_Insert_Input>;
  /** upsert condition */
  on_conflict?: Sub_Catalog_Packaging_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "sub_catalog_packaging". All fields are combined with a logical 'AND'. */
export type Sub_Catalog_Packaging_Bool_Exp = {
  _and?: Array<Sub_Catalog_Packaging_Bool_Exp> | null | undefined;
  _not?: Sub_Catalog_Packaging_Bool_Exp | null | undefined;
  _or?: Array<Sub_Catalog_Packaging_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  packaging?: Packaging_Bool_Exp | null | undefined;
  packaging_sku?: Int_Comparison_Exp | null | undefined;
  sub_catalog?: Sub_Catalog_Bool_Exp | null | undefined;
  sub_catalog_id?: Uuid_Comparison_Exp | null | undefined;
  supplier_company_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_Constraint =
  /** unique or primary key constraint on columns "sub_catalog_id", "packaging_sku", "supplier_company_id" */
  | 'sub_catalog_packaging_packaging_sku_supplier_company_id_sub_cat'
  /** unique or primary key constraint on columns "id" */
  | 'sub_catalog_packaging_pkey';

/** input type for inserting data into table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_Insert_Input = {
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  packaging?: Packaging_Obj_Rel_Insert_Input | null | undefined;
  packaging_sku?: number | null | undefined;
  sub_catalog?: Sub_Catalog_Obj_Rel_Insert_Input | null | undefined;
  sub_catalog_id?: string | null | undefined;
  supplier_company_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_On_Conflict = {
  constraint: Sub_Catalog_Packaging_Constraint;
  update_columns?: Array<Sub_Catalog_Packaging_Update_Column>;
  where?: Sub_Catalog_Packaging_Bool_Exp | null | undefined;
};

/** select columns of table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_company_id'
  /** column name */
  | 'updated_at';

/** update columns of table "sub_catalog_packaging" */
export type Sub_Catalog_Packaging_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'packaging_sku'
  /** column name */
  | 'sub_catalog_id'
  /** column name */
  | 'supplier_company_id'
  /** column name */
  | 'updated_at';

/** update columns of table "sub_catalog" */
export type Sub_Catalog_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'supplier_company_id'
  /** column name */
  | 'updated_at';

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

/** Boolean expression to compare columns of type "trade_item_unit_descriptor_enum". All fields are combined with logical 'AND'. */
export type Trade_Item_Unit_Descriptor_Enum_Comparison_Exp = {
  _eq?: Trade_Item_Unit_Descriptor_Enum | null | undefined;
  _in?: Array<Trade_Item_Unit_Descriptor_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Trade_Item_Unit_Descriptor_Enum | null | undefined;
  _nin?: Array<Trade_Item_Unit_Descriptor_Enum> | null | undefined;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: Array<User_Bool_Exp> | null | undefined;
  _not?: User_Bool_Exp | null | undefined;
  _or?: Array<User_Bool_Exp> | null | undefined;
  auth_provider_avatar_url?: String_Comparison_Exp | null | undefined;
  carrefour_id?: String_Comparison_Exp | null | undefined;
  comment_histories?: Comment_History_Bool_Exp | null | undefined;
  comment_histories_aggregate?: Comment_History_Aggregate_Bool_Exp | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  default_avatar?: Photo_Bool_Exp | null | undefined;
  default_avatar_photo_id?: Uuid_Comparison_Exp | null | undefined;
  email?: Citext_Comparison_Exp | null | undefined;
  email_privacy_setting?: Privacy_Setting_Enum_Comparison_Exp | null | undefined;
  first_name?: String_Comparison_Exp | null | undefined;
  google_id?: String_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  landline_phone?: String_Comparison_Exp | null | undefined;
  landline_privacy_setting?: Privacy_Setting_Enum_Comparison_Exp | null | undefined;
  last_name?: String_Comparison_Exp | null | undefined;
  mobile_phone?: String_Comparison_Exp | null | undefined;
  mobile_privacy_setting?: Privacy_Setting_Enum_Comparison_Exp | null | undefined;
  order_creators_histories?: Order_History_Bool_Exp | null | undefined;
  order_creators_histories_aggregate?: Order_History_Aggregate_Bool_Exp | null | undefined;
  order_suggestors_histories?: Order_History_Bool_Exp | null | undefined;
  order_suggestors_histories_aggregate?: Order_History_Aggregate_Bool_Exp | null | undefined;
  password?: String_Comparison_Exp | null | undefined;
  phone_deprecated?: String_Comparison_Exp | null | undefined;
  role_assignments?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignments_aggregate?: Role_Assignment_Aggregate_Bool_Exp | null | undefined;
  sendbird_access_token?: String_Comparison_Exp | null | undefined;
  staff_user?: Staff_User_Bool_Exp | null | undefined;
  time_zone_preference?: String_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
  user_product_recommendations?: User_Product_Recommendation_Bool_Exp | null | undefined;
  user_product_recommendations_aggregate?: User_Product_Recommendation_Aggregate_Bool_Exp | null | undefined;
};

/** unique or primary key constraints on table "user" */
export type User_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'PK_cace4a159ff9f2512dd42373760'
  /** unique or primary key constraint on columns "email" */
  | 'UQ_e12875dfb3b1d92d7d7c5377e22'
  /** unique or primary key constraint on columns "sendbird_access_token" */
  | 'user_sendbird_access_token_key';

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  auth_provider_avatar_url?: string | null | undefined;
  carrefour_id?: string | null | undefined;
  comment_histories?: Comment_History_Arr_Rel_Insert_Input | null | undefined;
  created_at?: string | null | undefined;
  default_avatar?: Photo_Obj_Rel_Insert_Input | null | undefined;
  default_avatar_photo_id?: string | null | undefined;
  email?: string | null | undefined;
  email_privacy_setting?: Privacy_Setting_Enum | null | undefined;
  first_name?: string | null | undefined;
  google_id?: string | null | undefined;
  id?: string | null | undefined;
  landline_phone?: string | null | undefined;
  landline_privacy_setting?: Privacy_Setting_Enum | null | undefined;
  last_name?: string | null | undefined;
  mobile_phone?: string | null | undefined;
  mobile_privacy_setting?: Privacy_Setting_Enum | null | undefined;
  order_creators_histories?: Order_History_Arr_Rel_Insert_Input | null | undefined;
  order_suggestors_histories?: Order_History_Arr_Rel_Insert_Input | null | undefined;
  password?: string | null | undefined;
  phone_deprecated?: string | null | undefined;
  role_assignments?: Role_Assignment_Arr_Rel_Insert_Input | null | undefined;
  sendbird_access_token?: string | null | undefined;
  staff_user?: Staff_User_Obj_Rel_Insert_Input | null | undefined;
  time_zone_preference?: string | null | undefined;
  updated_at?: string | null | undefined;
  user_product_recommendations?: User_Product_Recommendation_Arr_Rel_Insert_Input | null | undefined;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: User_On_Conflict | null | undefined;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: User_Bool_Exp | null | undefined;
};

export type User_Product_Family_Aggregate_Bool_Exp = {
  count?: User_Product_Family_Aggregate_Bool_Exp_Count | null | undefined;
};

export type User_Product_Family_Aggregate_Bool_Exp_Count = {
  arguments?: Array<User_Product_Family_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: User_Product_Family_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "user_product_family" */
export type User_Product_Family_Arr_Rel_Insert_Input = {
  data: Array<User_Product_Family_Insert_Input>;
  /** upsert condition */
  on_conflict?: User_Product_Family_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_family". All fields are combined with a logical 'AND'. */
export type User_Product_Family_Bool_Exp = {
  _and?: Array<User_Product_Family_Bool_Exp> | null | undefined;
  _not?: User_Product_Family_Bool_Exp | null | undefined;
  _or?: Array<User_Product_Family_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  global_setting?: Global_Product_Family_Enum_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  product_family?: Product_Family_Name_Enum_Comparison_Exp | null | undefined;
  product_family_sub_families?: Product_Sub_Family_Bool_Exp | null | undefined;
  product_family_sub_families_aggregate?: Product_Sub_Family_Aggregate_Bool_Exp | null | undefined;
  product_sub_family?: Product_Sub_Family_Name_Enum_Comparison_Exp | null | undefined;
  product_sub_family_family_name?: Product_Sub_Family_Bool_Exp | null | undefined;
  role_assignment?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignment_id?: Uuid_Comparison_Exp | null | undefined;
  updated_at?: Timestamptz_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "user_product_family" */
export type User_Product_Family_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_product_family_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'user_product_family_pkey';

/** input type for inserting data into table "user_product_family" */
export type User_Product_Family_Insert_Input = {
  created_at?: string | null | undefined;
  global_setting?: Global_Product_Family_Enum | null | undefined;
  id?: string | null | undefined;
  product_family?: Product_Family_Name_Enum | null | undefined;
  product_family_sub_families?: Product_Sub_Family_Arr_Rel_Insert_Input | null | undefined;
  product_sub_family?: Product_Sub_Family_Name_Enum | null | undefined;
  product_sub_family_family_name?: Product_Sub_Family_Obj_Rel_Insert_Input | null | undefined;
  role_assignment?: Role_Assignment_Obj_Rel_Insert_Input | null | undefined;
  role_assignment_id?: string | null | undefined;
  updated_at?: string | null | undefined;
};

/** on_conflict condition type for table "user_product_family" */
export type User_Product_Family_On_Conflict = {
  constraint: User_Product_Family_Constraint;
  update_columns?: Array<User_Product_Family_Update_Column>;
  where?: User_Product_Family_Bool_Exp | null | undefined;
};

/** select columns of table "user_product_family" */
export type User_Product_Family_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'global_setting'
  /** column name */
  | 'id'
  /** column name */
  | 'product_family'
  /** column name */
  | 'product_sub_family'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

/** update columns of table "user_product_family" */
export type User_Product_Family_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'global_setting'
  /** column name */
  | 'id'
  /** column name */
  | 'product_family'
  /** column name */
  | 'product_sub_family'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'updated_at';

export type User_Product_Recommendation_Aggregate_Bool_Exp = {
  count?: User_Product_Recommendation_Aggregate_Bool_Exp_Count | null | undefined;
};

export type User_Product_Recommendation_Aggregate_Bool_Exp_Count = {
  arguments?: Array<User_Product_Recommendation_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: User_Product_Recommendation_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "user_product_recommendation" */
export type User_Product_Recommendation_Arr_Rel_Insert_Input = {
  data: Array<User_Product_Recommendation_Insert_Input>;
  /** upsert condition */
  on_conflict?: User_Product_Recommendation_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "user_product_recommendation". All fields are combined with a logical 'AND'. */
export type User_Product_Recommendation_Bool_Exp = {
  _and?: Array<User_Product_Recommendation_Bool_Exp> | null | undefined;
  _not?: User_Product_Recommendation_Bool_Exp | null | undefined;
  _or?: Array<User_Product_Recommendation_Bool_Exp> | null | undefined;
  base_unit?: Base_Unit_Bool_Exp | null | undefined;
  base_unit_sku?: Int_Comparison_Exp | null | undefined;
  buying_company?: Company_Bool_Exp | null | undefined;
  buying_company_id?: Uuid_Comparison_Exp | null | undefined;
  company_id?: Uuid_Comparison_Exp | null | undefined;
  final_score?: Numeric_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  product?: Product_Bool_Exp | null | undefined;
  rank?: Int_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  user?: User_Bool_Exp | null | undefined;
  user_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "user_product_recommendation" */
export type User_Product_Recommendation_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_product_recommendation_pkey';

/** input type for inserting data into table "user_product_recommendation" */
export type User_Product_Recommendation_Insert_Input = {
  base_unit?: Base_Unit_Obj_Rel_Insert_Input | null | undefined;
  base_unit_sku?: number | null | undefined;
  buying_company?: Company_Obj_Rel_Insert_Input | null | undefined;
  buying_company_id?: string | null | undefined;
  company_id?: string | null | undefined;
  final_score?: number | null | undefined;
  id?: string | null | undefined;
  product?: Product_Obj_Rel_Insert_Input | null | undefined;
  rank?: number | null | undefined;
  sku?: number | null | undefined;
  user?: User_Obj_Rel_Insert_Input | null | undefined;
  user_id?: string | null | undefined;
};

/** on_conflict condition type for table "user_product_recommendation" */
export type User_Product_Recommendation_On_Conflict = {
  constraint: User_Product_Recommendation_Constraint;
  update_columns?: Array<User_Product_Recommendation_Update_Column>;
  where?: User_Product_Recommendation_Bool_Exp | null | undefined;
};

/** select columns of table "user_product_recommendation" */
export type User_Product_Recommendation_Select_Column =
  /** column name */
  | 'base_unit_sku'
  /** column name */
  | 'buying_company_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'final_score'
  /** column name */
  | 'id'
  /** column name */
  | 'rank'
  /** column name */
  | 'sku'
  /** column name */
  | 'user_id';

/** update columns of table "user_product_recommendation" */
export type User_Product_Recommendation_Update_Column =
  /** column name */
  | 'base_unit_sku'
  /** column name */
  | 'buying_company_id'
  /** column name */
  | 'company_id'
  /** column name */
  | 'final_score'
  /** column name */
  | 'id'
  /** column name */
  | 'rank'
  /** column name */
  | 'sku'
  /** column name */
  | 'user_id';

export type User_Role_Enum =
  | 'BUYER_DIRECTOR'
  | 'BUYER_FINANCE'
  | 'BUYER_MANAGER'
  | 'BUYER_OWNER'
  | 'COMPANY_ADMIN'
  | 'STAFF_ADMIN'
  | 'SUPPLIER_OWNER'
  | 'SUPPLIER_SALES_ADMIN'
  | 'SUPPLIER_SALES_REP';

/** Boolean expression to compare columns of type "user_role_enum". All fields are combined with logical 'AND'. */
export type User_Role_Enum_Comparison_Exp = {
  _eq?: User_Role_Enum | null | undefined;
  _in?: Array<User_Role_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: User_Role_Enum | null | undefined;
  _nin?: Array<User_Role_Enum> | null | undefined;
};

/** update columns of table "user" */
export type User_Update_Column =
  /** column name */
  | 'auth_provider_avatar_url'
  /** column name */
  | 'carrefour_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'default_avatar_photo_id'
  /** column name */
  | 'email'
  /** column name */
  | 'email_privacy_setting'
  /** column name */
  | 'first_name'
  /** column name */
  | 'google_id'
  /** column name */
  | 'id'
  /** column name */
  | 'landline_phone'
  /** column name */
  | 'landline_privacy_setting'
  /** column name */
  | 'last_name'
  /** column name */
  | 'mobile_phone'
  /** column name */
  | 'mobile_privacy_setting'
  /** column name */
  | 'password'
  /** column name */
  | 'phone_deprecated'
  /** column name */
  | 'sendbird_access_token'
  /** column name */
  | 'time_zone_preference'
  /** column name */
  | 'updated_at';

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: string | null | undefined;
  _gt?: string | null | undefined;
  _gte?: string | null | undefined;
  _in?: Array<string> | null | undefined;
  _is_null?: boolean | null | undefined;
  _lt?: string | null | undefined;
  _lte?: string | null | undefined;
  _neq?: string | null | undefined;
  _nin?: Array<string> | null | undefined;
};

export type Wishlist_Item_Aggregate_Bool_Exp = {
  count?: Wishlist_Item_Aggregate_Bool_Exp_Count | null | undefined;
};

export type Wishlist_Item_Aggregate_Bool_Exp_Count = {
  arguments?: Array<Wishlist_Item_Select_Column> | null | undefined;
  distinct?: boolean | null | undefined;
  filter?: Wishlist_Item_Bool_Exp | null | undefined;
  predicate: Int_Comparison_Exp;
};

/** input type for inserting array relation for remote table "wishlist_item" */
export type Wishlist_Item_Arr_Rel_Insert_Input = {
  data: Array<Wishlist_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: Wishlist_Item_On_Conflict | null | undefined;
};

/** Boolean expression to filter rows from the table "wishlist_item". All fields are combined with a logical 'AND'. */
export type Wishlist_Item_Bool_Exp = {
  _and?: Array<Wishlist_Item_Bool_Exp> | null | undefined;
  _not?: Wishlist_Item_Bool_Exp | null | undefined;
  _or?: Array<Wishlist_Item_Bool_Exp> | null | undefined;
  created_at?: Timestamptz_Comparison_Exp | null | undefined;
  id?: Uuid_Comparison_Exp | null | undefined;
  product?: Product_Bool_Exp | null | undefined;
  role_assignment?: Role_Assignment_Bool_Exp | null | undefined;
  role_assignment_id?: Uuid_Comparison_Exp | null | undefined;
  sku?: Int_Comparison_Exp | null | undefined;
  supplier?: Company_Bool_Exp | null | undefined;
  supplier_id?: Uuid_Comparison_Exp | null | undefined;
};

/** unique or primary key constraints on table "wishlist_item" */
export type Wishlist_Item_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'wishlist_item_pkey'
  /** unique or primary key constraint on columns "supplier_id", "sku", "role_assignment_id" */
  | 'wishlist_item_role_assignment_supplier_sku_uq'
  /** unique or primary key constraint on columns "supplier_id", "role_assignment_id" */
  | 'wishlist_item_role_assignment_supplier_uq';

/** input type for inserting data into table "wishlist_item" */
export type Wishlist_Item_Insert_Input = {
  created_at?: string | null | undefined;
  id?: string | null | undefined;
  product?: Product_Obj_Rel_Insert_Input | null | undefined;
  role_assignment?: Role_Assignment_Obj_Rel_Insert_Input | null | undefined;
  role_assignment_id?: string | null | undefined;
  sku?: number | null | undefined;
  supplier?: Company_Obj_Rel_Insert_Input | null | undefined;
  supplier_id?: string | null | undefined;
};

/** on_conflict condition type for table "wishlist_item" */
export type Wishlist_Item_On_Conflict = {
  constraint: Wishlist_Item_Constraint;
  update_columns?: Array<Wishlist_Item_Update_Column>;
  where?: Wishlist_Item_Bool_Exp | null | undefined;
};

/** select columns of table "wishlist_item" */
export type Wishlist_Item_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'supplier_id';

/** update columns of table "wishlist_item" */
export type Wishlist_Item_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'role_assignment_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'supplier_id';

export type AddPackagingsToSubCatalogsMutationVariables = Exact<{
  subCatalogPackagingsData: Array<Types.Sub_Catalog_Packaging_Insert_Input> | Types.Sub_Catalog_Packaging_Insert_Input;
  subCatalogsIds: Array<string> | string;
  now?: string | null | undefined;
}>;


export type AddPackagingsToSubCatalogsMutation = { insert_sub_catalog_packaging: { affected_rows: number } | null, update_sub_catalog: { affected_rows: number } | null };


export const AddPackagingsToSubCatalogsDocument = /*#__PURE__*/ gql`
    mutation AddPackagingsToSubCatalogs($subCatalogPackagingsData: [sub_catalog_packaging_insert_input!]!, $subCatalogsIds: [uuid!]!, $now: timestamptz) {
  insert_sub_catalog_packaging(objects: $subCatalogPackagingsData) {
    affected_rows
  }
  update_sub_catalog(
    where: {id: {_in: $subCatalogsIds}}
    _set: {updated_at: $now}
  ) {
    affected_rows
  }
}
    `;
export type AddPackagingsToSubCatalogsMutationFn = Apollo.MutationFunction<AddPackagingsToSubCatalogsMutation, AddPackagingsToSubCatalogsMutationVariables>;

/**
 * __useAddPackagingsToSubCatalogsMutation__
 *
 * To run a mutation, you first call `useAddPackagingsToSubCatalogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackagingsToSubCatalogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackagingsToSubCatalogsMutation, { data, loading, error }] = useAddPackagingsToSubCatalogsMutation({
 *   variables: {
 *      subCatalogPackagingsData: // value for 'subCatalogPackagingsData'
 *      subCatalogsIds: // value for 'subCatalogsIds'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useAddPackagingsToSubCatalogsMutation(baseOptions?: Apollo.MutationHookOptions<AddPackagingsToSubCatalogsMutation, AddPackagingsToSubCatalogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackagingsToSubCatalogsMutation, AddPackagingsToSubCatalogsMutationVariables>(AddPackagingsToSubCatalogsDocument, options);
      }
export type AddPackagingsToSubCatalogsMutationHookResult = ReturnType<typeof useAddPackagingsToSubCatalogsMutation>;
export type AddPackagingsToSubCatalogsMutationResult = Apollo.MutationResult<AddPackagingsToSubCatalogsMutation>;
export type AddPackagingsToSubCatalogsMutationOptions = Apollo.BaseMutationOptions<AddPackagingsToSubCatalogsMutation, AddPackagingsToSubCatalogsMutationVariables>;